import React, { useState, useEffect, useRef, useMemo } from 'react';
import Navbar from '../../../ReusableBlocks/Navbar';
import StickyStatusBar from './StickyStatusBar';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
// at the top with other imports
import ScheduleIngestionModal from "./ScheduleIngestionModal"; // adjust path

import { getTenantScenarios } from '../../../Redux/Dashboard/External/Yads/GetTenantScenGroupAction';
import { getYadsPollingStatus } from '../../../Redux/Dashboard/External/Yads/GetPollingStatusAction';
import { startYadsIngestion, postYadsIngestionReset } from '../../../Redux/Dashboard/External/Yads/YadDemoIngestionAction';
import { startYadsScheduleIngestion, postYadsScheduleReset } from '../../../Redux/Dashboard/External/Yads/YadsScheduleIngestionAction';
import { cancelYadsScheduledIngestion } from '../../../Redux/Dashboard/External/Yads/YadsCancelScheduleAction';

import { startYadsRecurringScheduleIngestion, postYadsRecurringReset } from '../../../Redux/Dashboard/External/Yads/YadsRecurringScheduleAction';
import {
    editYadsRecurringSchedule,
    patchYadsRecurringScheduleReset,
} from '../../../Redux/Dashboard/External/Yads/YadsEditRecurringAction.js';

import { cancelYadsRecurringScheduleIngestion } from '../../../Redux/Dashboard/External/Yads/YadsDeleteRecurringScheduleAction.js';

// + Onboard actions
import { onboardTenant, resetOnboardTenantSuccess } from '../../../Redux/Dashboard/External/USER_PROFILE/OnboardTenantAction';



import Yads_Ingestion_Scheduled_Edit from './Yads_Ingestion_Scheduled_Edit.js';
import Yads_Recurring_Scheduled_Edit from './Yads_Recurring_Schedule_edit.js';
import Switch from '../../../ReusableBlocks/Switch';
import { BsActivity } from "react-icons/bs";

import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import { useFeatureFlags } from '../../../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../../../FeatureFlags/featureFlagConstants';


import { updateTenantDetails, patchUserTenantReset } from '../../../Redux/Dashboard/External/Yads/UpdateTenantAction';
import { cancelIngestion } from '../../../Redux/Dashboard/External/Yads/YadsCancelIngestionAction.js';



import TenantDropdown from '../../../ReusableBlocks/TenantDropdown.js';


const Yads_Ingestion = () => {


    const dispatch = useDispatch();
    const { isFeatureEnabled } = useFeatureFlags();
    const enableIngestionScheduling = isFeatureEnabled(FEATURE_FLAGS.EnableIngestionScheduling);
    // keeps the last payload used to onboard so the user can retry
    const lastOnboardPayloadRef = useRef(null);
    const selectAllRef = React.useRef(null);
    const pollInFlightRef = React.useRef(false);
    // inside component:
    const supressOnboardToastRef = useRef(false);



    // ReFract



    // 🚀 Fetch tenant and scenario data
    const { loading: scenarioLoading, tenantOptions, scenarioGroups, error: scenarioError, } = useSelector((state) => state.YadsTenantScenario || {});


    // ✅ Correct way based on your reducer:
    const pollingStatus = useSelector(state => state.YadsStatus?.statusData);
    const pollingLoading = useSelector(state => state.YadsStatus?.loading);
    const pollingError = useSelector(state => state.YadsStatus?.error);

    // in Yads_Ingestion component
    const {
        result: scheduleResult,
        loading: scheduleLoading,
        error: scheduleError,
    } = useSelector(state => state.YadsSchedule || {});


    // Yads_Ingestion.jsx (top with other selectors)
    const {
        result: cancelResult,
        loading: cancelLoading,
        error: cancelError,
    } = useSelector(state => state.YadsCancelSchedule || {});


    const {
        result: recResult,
        loading: recLoading,
        error: recError,
    } = useSelector(state => state.YadsRecurringSchedule || {});


    // Yads_Ingestion.jsx (top with other selectors)
    const {
        result: cancelRecResult,
        loading: cancelRecLoading,
        error: cancelRecError,
    } = useSelector(state => state.YadsCancelRecurringSchedule || {});


    // select PATCH reducer state
    const {
        loading: patchLoading,
        result: patchResult,
        error: patchError,
    } = useSelector(s => s.YadsEditRecurring || {}); // use your reducer key



    // 🚀 Ingestion result
    const { ingestionResult, loading: ingestionLoading, error: ingestionError, } = useSelector(state => state.YadsIngestion || {});

    // const { scenarioGroupsArr, tenantOptions: mockTenants } = ingestionMockData;

    // One coordinated popup per user action
    const FLOW_IDLE = {
        active: false,
        mode: null,                 // 'immediate' | 'schedule'
        wantOnboard: false,
        onboard: {
            status: 'na',           // overall onboarding status
            msg: '',
            hasStepResponses: false,
            isProcess: { status: 'na', msg: '' },   // IS package upload
            controlM: { status: 'na', msg: '' },    // Control-M onboarding
            overall: { status: 'na', msg: '' },     // backend overall success/error
        },
        ingestion: { status: 'idle', msg: '' }
    };
    const [flow, setFlow] = useState(FLOW_IDLE);



    const DAY_CODE_TO_FULL = {
        MO: "Monday", TU: "Tuesday", WE: "Wednesday",
        TH: "Thursday", FR: "Friday", SA: "Saturday", SU: "Sunday",
    };
    const to24hStr = (h12, m2, ampm) => {
        let h = parseInt(h12, 10) || 0;
        const mm = String(parseInt(m2, 10) || 0).padStart(2, "0");
        if (ampm === "PM" && h < 12) h += 12;
        if (ampm === "AM" && h === 12) h = 0;
        return `${String(h).padStart(2, "0")}:${mm}`;
    };



    // Small helper to DRY tenant/scenario collection; returns null if validation fails
    const getTenantAndScenarios = () => {
        let tenantData = {};
        if (useNewTenant) {
            const { tenantUrl, secretKey, accessKey, username, password, itsmUrl } = newTenant;
            if (!tenantUrl || !secretKey || !accessKey || !username || !password) {
                Swal.fire("Incomplete tenant details", "Please fill all new tenant fields.", "warning");
                return null;
            }
            tenantData = { tenantUrl, itsmUrl, key: accessKey, secretKey, username, password };
        } else {
            const matched = tenantOptions.find(t => t.tenantUrl === tenantDropdownValue);
            if (!matched) {
                Swal.fire("Tenant missing", "Please select a tenant or add a new one.", "warning");
                return null;
            }
            tenantData = {
                tenantUrl: matched.tenantUrl,
                itsmUrl: matched.itsmUrl,
                key: matched.key,
                secretKey: matched.secretKey,
                username: matched.username,
                password: matched.password,
            };
        }

        const scenariosPayload = buildScenariosPayloadFromSelectedItems();
        if (!scenariosPayload.length) {
            Swal.fire("No scenarios", "Please select at least one scenario or group.", "warning");
            return null;
        }

        return { tenantData, scenariosPayload };
    };




    const [, setGroupScenarioSelectionMap] = useState({});
    // Helpers
    const isInitTitle = (title = "") => /-Init$/i.test(title.trim());
    const isInitScenario = (s) => isInitTitle(s?.title);

    const [selectedGroup, setSelectedGroup] = useState(null); // e.g., "SGD-Retail"
    const [selectedGroupScenarios, setSelectedGroupScenarios] = useState([]);
    const [, setGroupCheckboxes] = useState({}); // e.g., { "SGD-Retail": 'checked' | 'partial' | 'none' }
    const [tenantDropdownValue, setTenantDropdownValue] = useState("");

    // Tenant dropdown & new tenant toggle state
    const [useNewTenant, setUseNewTenant] = useState(false);

    const [tenantInput, setTenantInput] = useState('');
    const [itsmInput, setItsmInput] = useState('');
    const [hasFocusedTenant, setHasFocusedTenant] = useState(false);
    const [hasFocusedITSM, setHasFocusedITSM] = useState(false);

    const [editOpen, setEditOpen] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);

    const [editOpenRecurring, setEditOpenRecurring] = useState(false);
    const [editingRecordRecurring, setEditingRecordRecurring] = useState(null);

    const [newTenant, setNewTenant] = useState({
        tenantUrl: "",
        secretKey: "",
        accessKey: "",
        username: "",
        password: "",
        itsmUrl: "", // optional if needed
    });



    // Edit Saved Tenant Details
    // which tenant is selected in "Previously Used Tenant"
    const selectedTenant = useMemo(
        () => (tenantOptions || []).find(t => t.tenantUrl === tenantDropdownValue) || null,
        [tenantOptions, tenantDropdownValue]
    );
    const [isTenantEditOpen, setIsTenantEditOpen] = useState(false);
    const [tenantEditDraft, setTenantEditDraft] = useState(null);

    // 🚨 NEW: convenience flags
    const isSharedSelectedTenant = selectedTenant?.type === 'booked';
    const canEditSelectedTenant = !!selectedTenant && !isSharedSelectedTenant;


    const [selectedItems, setSelectedItems] = useState([]);

    // Onboard-for-new-tenant UI state
    const [ntOnboardOptIn, setNtOnboardOptIn] = useState(false);
    const [ntHannaPwd, setNtHannaPwd] = useState('');
    // Onboard redux state
    const onboardState = useSelector(state => state.OnboardTenant);


    // RTIC Flag
    const [rticReset, setRticReset] = useState(false);
    const [createHealthIndicator, setCreateHealthIndicator] = useState(false);



    const [scenarioModes, setScenarioModes] = useState({}); // key: group, value: 'Default' | 'Advanced' | 'Reset'


    // inside component:
    const [showSchedule, setShowSchedule] = useState(false);
    const [showHealthIndicatorSchedulingWarning, setShowHealthIndicatorSchedulingWarning] = useState(false);

    useEffect(() => {
        if (!enableIngestionScheduling) {
            setShowSchedule(false);
            setEditOpen(false);
            setEditOpenRecurring(false);
        }
    }, [enableIngestionScheduling]);

    // Helper: figure tenant URL shown in the modal
    const selectedTenantForModal = useNewTenant
        ? (newTenant?.tenantUrl || "")
        : (tenantDropdownValue || "");



    const globalLoading = ingestionLoading || scenarioLoading || scheduleLoading || cancelLoading || onboardState?.loading
        || recLoading || cancelRecLoading || patchLoading
        ;





    const getCurrentMode = () => {
        if (!selectedGroup) return 'Default';
        return scenarioModes[selectedGroup] || 'Default';
    };

    const selectedGroupSupportsHealthIndicator =
        (scenarioGroups || []).find(g => g.title === selectedGroup)?.supportsHealthIndicator === true;




    // Detect user's IANA tz (e.g., "Asia/Kolkata")
    const USER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';


    // Common IANA → human abbrev
    const TZ_ABBREV_MAP = {
        'Asia/Kolkata': 'IST',
        'Asia/Calcutta': 'IST',    // ← alias some browsers use
        'America/Los_Angeles': 'PT',
        'America/Denver': 'MT',
        'America/Chicago': 'CT',
        'America/New_York': 'ET',
        'Europe/London': 'BST',       // during DST; browser may still return GMT in winter
        'Europe/Paris': 'CET',        // (or CEST in summer; browser may give short name)
        'Europe/Berlin': 'CET',
        'Asia/Dubai': 'GST',

    };

    // Friendly TZ label: prefer well-known abbrevs; else use browser short name;
    const friendlyTz = (tz, date = new Date()) => {
        if (TZ_ABBREV_MAP[tz]) return TZ_ABBREV_MAP[tz];
        try {
            const parts = new Intl.DateTimeFormat('en-US', {
                timeZone: tz,
                timeZoneName: 'short',
            }).formatToParts(date);
            const short = parts.find(p => p.type === 'timeZoneName')?.value || '';
            if (short.startsWith('GMT')) {
                const sign = short.includes('-') ? '-' : '+';
                const hhmm = short.split(sign)[1] || '0';
                const [h, m = '00'] = hhmm.split(':');
                const pad = n => String(n).padStart(2, '0');
                return `UTC${sign}${pad(Number(h))}:${pad(Number(m))}`;
            }
            return short; // e.g., PDT, CEST, etc.
        } catch {
            return tz; // fallback to IANA id
        }
    };

    // Pretty local-time formatter → "Sun, 7 Sep 2025 • 9:45 PM IST"
    const formatInTzPretty = (iso, tz = USER_TZ) => {
        if (!iso) return '-';
        try {
            const d = new Date(iso);
            // Use en-GB for "7 Sep 2025" style (no leading zero; short month)
            const datePart = new Intl.DateTimeFormat('en-GB', {
                weekday: 'short',
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                timeZone: tz,
            }).format(d)
                // Some browsers show "Sept" – standardize to "Sep"
                .replace('Sept', 'Sep');

            const abbr = friendlyTz(tz, d);
            // Time with AM/PM; some browsers give lowercase—normalize to uppercase
            let timePart = new Intl.DateTimeFormat('en-GB', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
                timeZone: tz,
            }).format(d);
            timePart = timePart.replace(/\s?(am|pm)$/i, (_, ap) => ` ${ap.toUpperCase()}`);

            return `${datePart} • ${timePart}\u00A0${abbr}`;
        } catch {
            return iso;
        }
    };


    // 🔹 Take ISO (backend UTC) → local 24h time + "10:30 AM UTC+08:00" label
    const formatRecurringTimeFromIso = (iso, tz = USER_TZ) => {
        if (!iso) {
            return {
                time24: "00:00",
                label: "-",
            };
        }

        try {
            const d = new Date(iso); // ISO with Z → instant in time

            // 24h "HH:MM" in the user's timezone
            const parts24 = new Intl.DateTimeFormat("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
                timeZone: tz,
            }).formatToParts(d);

            const hh = parts24.find(p => p.type === "hour")?.value ?? "00";
            const mm = parts24.find(p => p.type === "minute")?.value ?? "00";
            const time24 = `${hh}:${mm}`;

            // 12h time for display: "10:30 AM"
            let time12 = new Intl.DateTimeFormat("en-GB", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
                timeZone: tz,
            }).format(d);
            time12 = time12.replace(/\s?(am|pm)$/i, (_, ap) => ` ${ap.toUpperCase()}`);

            const abbr = friendlyTz(tz, d); // e.g. "UTC+08:00"

            return {
                time24,
                label: `${time12} ${abbr}`, // "10:30 AM UTC+08:00"
            };
        } catch (e) {
            console.error("Bad scheduledTime ISO from backend:", iso, e);
            return {
                time24: "00:00",
                label: "-",
            };
        }
    };

    const normalizeTimezone = (tz) =>
        tz === "Asia/Calcutta" ? "Asia/Kolkata" : tz;

    const FULLDAY_TO_CODE = {
        Monday: "MO",
        Tuesday: "TU",
        Wednesday: "WE",
        Thursday: "TH",
        Friday: "FR",
        Saturday: "SA",
        Sunday: "SU",
    };


    const safeFormatEnd = (iso) => {
        if (!iso) return { type: "noEnd" };
        return { type: "byDate", dateText: formatInTzPretty(iso, USER_TZ) };
    };


    // 🔁 FINAL recurringRows mapping (using ISO scheduledTime from backend)
    const { recurringRows } = (() => {
        const raw = Array.isArray(pollingStatus?.recurring)
            ? pollingStatus.recurring
            : [];

        const rows = raw.map((item) => {
            // Full day names from API: ["Tuesday","Saturday"]
            const daysFull = Array.isArray(item.frequency?.days)
                ? item.frequency.days
                : [];

            // Convert to codes for the UI: ["TU","SA"]
            const daysCodes = daysFull
                .map((d) => FULLDAY_TO_CODE[d] || d)
                .filter(Boolean);

            // Scenario labels with counts
            const scenarios = (item.selectedScenarios || []).map((s) => {
                const cnt = Number(s.count ?? 1);
                return cnt > 1 ? `${s.title} x ${cnt}` : s.title;
            });

            // ⬇️ NEW: use ISO scheduledTime → user’s local time
            const { time24, label } = formatRecurringTimeFromIso(
                item.scheduledTime,   // e.g. "2025-11-19T08:30:00Z"
                USER_TZ
            );

            return {
                id: item.scheduleId,
                scheduleId: item.scheduleId,
                tenant: item.tenantUrl,
                scenarios,

                frequency: daysFull.length > 1 ? "weeklyDays" : "oncePerWeek",
                daysOfWeek: daysCodes,

                // What StickyStatusBar actually renders
                timeText: label, // "4:40 PM UTC+08:00"
                nextRunText: daysFull.length
                    ? `${daysFull[0]} at ${label}` // "Tuesday at 4:40 PM UTC+08:00"
                    : label,

                // Handy for edit popup defaults if you want
                uiTime24: time24,    // "HH:MM" in user's tz
                uiTimezone: USER_TZ, // viewer's timezone

                end: safeFormatEnd(item.endDate),
                enabled: item.enabled === true,

                // keep raw for edit/toggle
                scheduledTimeIso: item.scheduledTime,
                _raw: item,
            };
        });

        return { recurringRows: rows };
    })();









    const { scheduledRows } = (() => {
        const raw =
            Array.isArray(pollingStatus?.scheduled) ? pollingStatus.scheduled : [];

        const rows = raw.map((item) => {
            const scenarios =
                (item.scenarioProgress || []).map(sp => {
                    const cnt = Number(sp.count ?? 1);
                    return cnt > 1 ? `${sp.title} x ${cnt}` : sp.title;
                });

            return {
                id: item.taskId || `${item.tenantUrl}|${item.scheduledDate}`,
                tenant: item.tenantUrl,
                scenarios,
                // Convert UTC → user's local timezone for display
                scheduledFor: formatInTzPretty(item.scheduledDate, USER_TZ),
                _raw: item,
            };
        });

        return { scheduledRows: rows };
    })();


    // NEW: flag if any scheduled rows exist
    const anyScheduled =
        Array.isArray(pollingStatus?.scheduled) && pollingStatus.scheduled.length > 0;



    const { ingestionData } = (() => {
        const container = pollingStatus;
        const raw = Array.isArray(container)
            ? container
            : Array.isArray(container?.current)
                ? container.current
                : [];

        const parseTenantError = (e) => {
            if (!e) return null;
            try {
                const arr = typeof e === 'string' ? JSON.parse(e) : e;
                if (Array.isArray(arr) && arr.length) {
                    return arr
                        .map(o =>
                            [o.messageType, o.messageText, o.messageAppendedText]
                                .filter(Boolean)
                                .join(' ')
                        )
                        .join(' | ');
                }
                return typeof arr === 'string' ? arr : JSON.stringify(arr);
            } catch {
                return String(e);
            }
        };

        // helpers to normalize statuses
        // const isDone = (s) => /^(completed|success|succeeded)$/i.test(s);
        // const isFailed = (s) => /^(failed|error|errored|aborted|canceled|cancelled)$/i.test(s);
        // const isInProg = (s) => /(in[-_ ]?progress|running|pending|queued|starting|started)/i.test(s);
        // helpers to normalize statuses
        const isDone = (s) => /^(completed|success|succeeded)$/i.test(s);
        const isFailed = (s) => /^(failed|error|errored|aborted)$/i.test(s);

        // running == actually executing; NOT pending/queued
        const isRunning = (s) => /(in[-_ ]?progress|running|processing|executing|active|started|starting)/i.test(s);

        // queued/pending but not yet executing
        const isQueued = (s) => /\b(pending|queued|queue|waiting|scheduled)\b/i.test(s);

        // NEW: cancelled (final state)
        const isCancelled = (s) =>
            /\b(canceled|cancelled)\b/i.test(s);

        // NEW: cancellation requested but not yet fully cancelled
        const isCancelRequested = (s) =>
            /(cancellation[_ ]?requested|cancel[_ ]?request(ed)?)/i.test(s);


        const mapped = raw.map((tenant) => {
            const scenarios = (tenant.scenarioProgress || []).map((item) => {
                const st = String(item.status || '').toLowerCase();
                let type;
                if (isDone(st)) type = 'success';
                else if (isFailed(st)) type = 'failed';
                else if (isCancelled(st)) type = 'cancelled';
                else if (isRunning(st)) type = 'in-progress';  // optional new class
                else if (isQueued(st)) type = 'pending';       // visually gray clock
                else type = 'pending';

                const count = Number(item.count ?? 1);
                const completedCount = Number(item.completedCount ?? 0);
                const name = (item.title || '') + (count > 1 ? ` x ${count}` : '');

                const steps = count > 1
                    ? Array.from({ length: count }, (_, i) => ({
                        label: `(${i + 1}/${count})`,
                        status: i + 1 <= completedCount ? 'success'
                            : isFailed(st) ? 'failed'
                                : isRunning(st) ? 'in-progress'
                                    : 'pending',
                    }))
                    : undefined;

                return { name, type, steps };
            });

            // prefer backend overallStatus, but normalize to our flags
            const s = String(tenant.overallStatus || '').toLowerCase();
            let status = {
                done: isDone(s),
                inProgress: isRunning(s),
                queued: isQueued(s),
                failed: isFailed(s),
                cancelled: isCancelled(s),
                cancelRequested: isCancelRequested(s),
            };

            // Fallback if overallStatus missing/unknown: derive from scenarios
            if (!(status.done || status.inProgress || status.failed || status.queued || status.cancelled || status.cancelRequested)) {
                const hasFailed = scenarios.some(sc => sc.type === 'failed');
                const hasRunning = scenarios.some(sc => sc.type === 'in-progress');
                const hasQueued = scenarios.some(sc => sc.type === 'pending');
                const hasCancelled = scenarios.some(sc => sc.type === 'cancelled');
                status = {
                    done: !hasFailed && !hasRunning && !hasQueued && !hasCancelled && scenarios.length > 0,
                    inProgress: hasRunning,
                    queued: hasQueued,
                    failed: hasFailed,
                    cancelled: hasCancelled,
                    cancelRequested: false,
                };
            }
            return {
                tenant: tenant.tenantUrl,
                scenarios,
                status,
                errorText: parseTenantError(tenant.errorMsg), // 👈 NEW
                duration: tenant.duration ?? null,
                // 👇 ADD THESE LINES
                completedAtRaw: tenant.completedAt ?? null,
                completedAt: tenant.completedAt
                    ? formatInTzPretty(tenant.completedAt, USER_TZ)
                        .replace(/^[A-Za-z]{3},\s*/, '') // <-- removes "Sun,"
                    : null,
                // 👇 IMPORTANT: wire through backend task id
                taskId: tenant.taskId
            };
        });

        return {
            ingestionData: mapped,
            shouldShowBar: raw.length > 0,
        };
    })();



    // keep polling while there’s progress, or while first load is happening
    const anyInProgress = ingestionData?.some(t => t?.status?.inProgress);
    const anyQueued = ingestionData?.some(t => t?.status?.queued);

    const hasAnyData = (ingestionData?.length > 0) || anyScheduled;
    const shouldPoll = anyInProgress || anyQueued || anyScheduled || (!hasAnyData && pollingLoading);

    useEffect(() => {
        dispatch(getTenantScenarios());
        dispatch(getYadsPollingStatus());
    }, [dispatch]);


    useEffect(() => {
        if (tenantOptions?.length && !tenantDropdownValue) {
            setTenantDropdownValue(tenantOptions[0].tenantUrl);
        }
    }, [tenantOptions, tenantDropdownValue]);

    // ✅ Recurring schedule: success / error toast + refresh
    useEffect(() => {
        if (recLoading) return;

        const ok =
            recResult &&
            (
                recResult?.success === true ||
                String(recResult?.status || '').toLowerCase() === 'success' ||
                (typeof recResult?.success === 'string' && recResult.success.length > 0)
            );

        if (recError) {
            Swal.fire({
                icon: 'error',
                title: 'Recurring Schedule Failed',
                text: String(recError),
                confirmButtonColor: '#05264e',
            });
            dispatch(postYadsRecurringReset());
            return;
        }

        if (!recResult) return;

        if (ok) {
            Swal.fire({
                icon: 'success',
                title: 'Recurring Schedule Created',
                text: recResult?.message || recResult?.success || 'Your recurring ingestion has been scheduled.',
                confirmButtonColor: '#05264e',
            }).then(() => {
                // close modal if it’s open and refresh lists
                setShowSchedule(false);
                setShowHealthIndicatorSchedulingWarning(false);
                dispatch(getYadsPollingStatus());
                dispatch(getTenantScenarios());
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Recurring Schedule Failed',
                text: recResult?.error || 'The server returned a failure response.',
                confirmButtonColor: '#05264e',
            });
        }

        // always reset reducer state after handling
        dispatch(postYadsRecurringReset());
    }, [recLoading, recResult, recError, dispatch]);


    useEffect(() => {
        if (tenantOptions?.length) {
            console.log("✅ Tenant Options:", tenantOptions);
        }
        if (scenarioGroups?.length) {
            console.log("✅ Scenario Groups:", scenarioGroups);
        }
        if (scenarioLoading) {
            console.error("❌ Error loading tenant scenarios:", scenarioError);
        }
    }, [tenantOptions, scenarioGroups, scenarioError]);


    useEffect(() => {
        // else if (pollingError) {
        //     Swal.fire("Polling Error", pollingError, "error");
        // } 
        if (scenarioError) {
            Swal.fire("Failed to Load Scenario Data", scenarioError, "error");
        }
    }, [ingestionError, pollingError, scenarioError]);




    useEffect(() => {
        if (ingestionLoading) return;

        const ok = ingestionResult && (
            ingestionResult?.success === true ||
            String(ingestionResult?.status || '').toLowerCase() === 'success' ||
            (typeof ingestionResult?.success === 'string' && ingestionResult.success.length > 0)
        );

        // During coordinated flow → just record outcome, no direct toasts
        if (flow.active && flow.mode === 'immediate') {
            if (ingestionError) {
                setFlow(prev => ({ ...prev, ingestion: { status: 'error', msg: String(ingestionError) } }));
            } else if (ingestionResult) {
                setFlow(prev => ({ ...prev, ingestion: { status: ok ? 'success' : 'error', msg: ingestionResult?.message || ingestionResult?.success || ingestionResult?.error || '' } }));
            }
            dispatch(postYadsIngestionReset());
            return;
        }

        // Standalone behavior when not in a flow (unchanged pattern)
        if (ingestionError) {
            Swal.fire({ icon: 'error', title: 'Failed to start ingestion', text: String(ingestionError) });
        } else if (ingestionResult) {
            if (ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Ingestion Submitted',
                    text: ingestionResult?.message || ingestionResult?.success || 'You can track progress in the bottom status bar.',
                    confirmButtonColor: '#05264e',
                }).then(() => {
                    clearYadsLocalStorage();
                    dispatch(getYadsPollingStatus());
                });
            } else {
                Swal.fire({ icon: 'error', title: 'Failed to start ingestion', text: ingestionResult?.message || 'The server returned a failure response.' });
            }
            dispatch(postYadsIngestionReset());
        }
    }, [flow.active, flow.mode, ingestionLoading, ingestionError, ingestionResult, dispatch]);


    const clearYadsLocalStorage = () => {
        ['yadsModes', 'yadsSelections', 'yadsSelectedItems'].forEach(k => localStorage.removeItem(k));
    };



    // strict-mode guard
    const handledRef = React.useRef(false);
    // ✅ SUCCESS
    useEffect(() => {
        if (handledRef.current) return;
        if (!patchLoading && patchResult) {
            handledRef.current = true;

            (async () => {
                const res = await Swal.fire({
                    icon: 'success',
                    title: 'Updated',
                    text: 'Recurring schedule updated successfully.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#05264e',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });

                // reset slice BEFORE closing, so new renders don't see a truthy result
                dispatch(patchYadsRecurringScheduleReset());

                if (res.isConfirmed) {
                    setEditOpenRecurring(false);           // ✅ actually close the popup here
                    dispatch(getYadsPollingStatus()); // refresh list if needed
                }

                // release for next run when a *new* result arrives
                handledRef.current = false;
            })();
        }
    }, [patchLoading, patchResult, dispatch]);

    // ❌ ERROR
    useEffect(() => {
        if (handledRef.current) return;
        if (!patchLoading && patchError) {
            handledRef.current = true;

            (async () => {
                await Swal.fire({
                    icon: 'error',
                    title: 'Update failed',
                    text: patchError || 'Something went wrong.',
                    confirmButtonColor: '#05264e',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });

                dispatch(patchYadsRecurringScheduleReset());
                handledRef.current = false;
            })();
        }
    }, [patchLoading, patchError, dispatch]);


    useEffect(() => {
        if (!shouldPoll) return;

        let canceled = false;
        let timerId = null;

        const POLL_MS = 120000; // 2 minutes

        const tick = async () => {
            if (canceled) return;

            if (document.hidden) {
                timerId = setTimeout(tick, POLL_MS);
                return;
            }

            if (!pollInFlightRef.current) {
                pollInFlightRef.current = true;
                try {
                    await dispatch(getYadsPollingStatus());
                } catch {
                    // swallow
                } finally {
                    pollInFlightRef.current = false;
                }
            }

            timerId = setTimeout(tick, POLL_MS);
        };

        // do NOT call immediately on mount
        timerId = setTimeout(tick, POLL_MS);

        return () => {
            canceled = true;
            if (timerId) clearTimeout(timerId);
        };
    }, [dispatch, shouldPoll]);




    useEffect(() => {
        if (scheduleLoading) return;

        const ok = scheduleResult && (
            scheduleResult?.success === true ||
            String(scheduleResult?.status || '').toLowerCase() === 'success' ||
            (typeof scheduleResult?.success === 'string' && scheduleResult.success.length > 0)
        );

        // During coordinated flow → just record outcome
        if (flow.active && flow.mode === 'schedule') {
            if (scheduleError) {
                setFlow(prev => ({ ...prev, ingestion: { status: 'error', msg: String(scheduleError) } }));
            } else if (scheduleResult) {
                setFlow(prev => ({ ...prev, ingestion: { status: ok ? 'success' : 'error', msg: scheduleResult?.success || scheduleResult?.error || '' } }));
            }
            dispatch(postYadsScheduleReset());
            return;
        }

        // Standalone behavior when not in a flow (unchanged pattern)
        if (scheduleError) {
            Swal.fire("Schedule Failed", scheduleError, "error");
        } else if (scheduleResult) {
            if (ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Ingestion Scheduled',
                    text: scheduleResult?.success || 'You can track it in the status bar once it starts.',
                    confirmButtonColor: '#05264e',
                });
                setShowSchedule(false);
                setShowHealthIndicatorSchedulingWarning(false);
                dispatch(postYadsScheduleReset());
                dispatch(getYadsPollingStatus());
                dispatch(getTenantScenarios());
            } else {
                Swal.fire("Schedule Failed", scheduleResult?.error || 'The server returned a failure response.', "error");
                dispatch(postYadsScheduleReset());
            }
        }
    }, [flow.active, flow.mode, scheduleLoading, scheduleError, scheduleResult, dispatch]);





    // success / error feedback
    useEffect(() => {
        if (cancelError) {
            Swal.fire("Cancel Failed", cancelError, "error");
        } else if (cancelResult) {
            const ok =
                cancelResult?.success === true ||
                String(cancelResult?.status || '').toLowerCase() === 'success' ||
                (typeof cancelResult?.success === 'string' && cancelResult.success.length > 0);

            if (ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Schedule Cancelled',
                    text: cancelResult?.success || 'The scheduled ingestion was cancelled.',
                    confirmButtonColor: '#05264e',
                });
                dispatch({ type: 'DELETE_YADS_SCHEDULE_RESET' });
                dispatch(getYadsPollingStatus()); // refresh list
            } else {
                Swal.fire(
                    "Cancel Failed",
                    cancelResult?.error || 'The server returned a failure response.',
                    "error"
                );
                dispatch({ type: 'DELETE_YADS_SCHEDULE_RESET' });
            }
        }
    }, [cancelResult, cancelError, dispatch]);






    // Recurring schedule Cancel effect
    // success / error feedback
    useEffect(() => {
        if (cancelRecError) {
            Swal.fire("Cancel Failed", cancelRecError, "error");
        } else if (cancelRecResult) {
            const ok =
                cancelRecResult?.success === true ||
                String(cancelRecResult?.status || '').toLowerCase() === 'success' ||
                (typeof cancelRecResult?.success === 'string' && cancelRecResult.success.length > 0);

            if (ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Recurring Deleted',
                    text: cancelRecResult?.success || 'The Recurring ingestion was deleted.',
                    confirmButtonColor: '#05264e',
                });
                dispatch({ type: 'DELETE_YADS_RECURRING_SCHEDULE_RESET' });
                dispatch(getYadsPollingStatus()); // refresh list
            } else {
                Swal.fire(
                    "Cancel Failed",
                    cancelRecResult?.error || 'The server returned a failure response.',
                    "error"
                );
                dispatch({ type: 'DELETE_YADS_RECURRING_SCHEDULE_RESET' });
            }
        }
    }, [cancelRecResult, cancelRecError, dispatch]);



    useEffect(() => {
        if (!onboardState?.error) return;

        const rawRes =
            onboardState?.data ||
            (typeof onboardState?.error === 'object' ? onboardState.error : onboardState.error);

        const parsed = parseOnboardFlowResponse(rawRes, 'error');

        if (flow.active) {
            setFlow(prev => ({
                ...prev,
                onboard: parsed,
            }));
        } else {
            showRetryableOnboardError(parsed?.overall?.msg || parsed?.msg || 'Onboarding failed.');
        }

        dispatch(resetOnboardTenantSuccess());
    }, [onboardState?.error, onboardState?.data, flow.active, dispatch]);


    useEffect(() => {
        if (!onboardState?.success) return;

        const rawRes =
            onboardState?.data ||
            (typeof onboardState?.success === 'object' ? onboardState.success : onboardState.success);

        const parsed = parseOnboardFlowResponse(rawRes, 'success');

        if (flow.active) {
            setFlow(prev => ({ ...prev, onboard: parsed }));
        } else if (!supressOnboardToastRef.current) {
            Swal.fire({
                icon: parsed.status === 'error' ? 'error' : 'success',
                title: parsed.overall?.status === 'error' ? 'Onboarding incomplete' : 'Onboarding completed',
                html: parsed.hasStepResponses
                    ? `
                    <div style="text-align:left;">
                        <p><strong>IS Package:</strong> ${yadsEscapeHtml(parsed.isProcess?.msg || '-')}</p>
                        <p><strong>Control-M:</strong> ${yadsEscapeHtml(parsed.controlM?.msg || '-')}</p>
                        <p><strong>Overall:</strong> ${yadsEscapeHtml(parsed.overall?.msg || parsed.msg || '-')}</p>
                    </div>
                  `
                    : `
                    <div style="text-align:left;">
                        <p><strong>${yadsEscapeHtml(parsed.overall?.msg || parsed.msg || 'Onboarding completed.')}</strong></p>
                    </div>
                  `,
                confirmButtonColor: '#05264e',
            });
        }

        dispatch(resetOnboardTenantSuccess());
    }, [onboardState?.success, onboardState?.data, flow.active, dispatch]);



    // Safe HTML escaping for message strings
    const yadsEscapeHtml = (str = '') =>
        String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');


    // inject once
    // inject once
    const ensureYadsSwalStyles = () => {
        const css = `
/* popup shell */
.swal2-popup.yads-swal{
  padding:20px 20px 16px;
  border-radius:18px;
}
.swal2-popup.yads-swal .swal2-title{
  font-size:24px;
  font-weight:800;
  color:#0f172a;
  margin-bottom:10px;
}
.swal2-popup.yads-swal .swal2-html-container{
  margin:0;
  padding:0;
}

/* layout */
.yads-outcomeGrid{
  display:grid;
  grid-template-columns:1fr;
  gap:12px;
  margin-top:4px;
}

/* card */
.yads-card{
  width:100%;
  background:#ffffff;
  border:1px solid #e5e7eb;
  border-radius:18px;
  box-shadow:0 2px 8px rgba(15,23,42,.05);
  padding:14px 16px;
  text-align:left;
}

/* compact row */
.yads-cardRow{
  display:grid;
  grid-template-columns:48px minmax(0, 1fr);
  gap:12px;
  align-items:flex-start;
}

/* icon */
.yads-left{
  padding-top:2px;
}
.yads-badge{
  width:40px;
  height:40px;
  border-radius:9999px;
  display:grid;
  place-items:center;
  font-weight:800;
  font-size:20px;
  box-shadow:inset 0 0 0 1px rgba(0,0,0,.04);
}
.yads-badge--success{background:#ecfdf5;color:#059669}
.yads-badge--warn{background:#fff7ed;color:#ea580c}
.yads-badge--error{background:#fef2f2;color:#dc2626}

/* right */
.yads-right{
  min-width:0;
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  text-align:left;
  gap:8px;
}

/* top line */
.yads-titleLine{
  width:100%;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:10px;
  flex-wrap:nowrap;
}
.yads-card__title{
  min-width:0;
  margin:0;
  font-size:16px;
  line-height:1.25;
  font-weight:800;
  color:#0f172a;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

/* status chip */
.yads-chip{
  flex:0 0 auto;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  height:30px;
  padding:0 12px;
  border-radius:9999px;
  font-size:12px;
  font-weight:700;
  white-space:nowrap;
}
.yads-chip--success{background:#e8faf0;color:#0f766e}
.yads-chip--warn{background:#fff1e6;color:#9a3412}
.yads-chip--error{background:#fde8e8;color:#b91c1c}

/* message area */
.yads-card__msgWrap{
  width:100%;
  background:#f8fafc;
  border:1px solid #e2e8f0;
  border-radius:12px;
  padding:10px 12px;
}
.yads-card__msg{
  margin:0;
  color:#475569;
  line-height:1.45;
  font-size:14px;
  word-break:break-word;
}

/* retry button */
.yads-btn{
  margin-top:2px;
  display:inline-flex;
  align-items:center;
  gap:8px;
  border:1px solid #cbd5e1;
  border-radius:9999px;
  background:#fff;
  padding:8px 14px;
  font-size:13px;
  font-weight:700;
  color:#0f172a;
  cursor:pointer;
  transition:all .15s ease;
}
.yads-btn:hover{
  background:#f8fafc;
  box-shadow:0 1px 2px rgba(16,24,40,.08);
  border-color:#94a3b8;
}
.yads-btn:focus{
  outline:none;
  box-shadow:0 0 0 3px rgba(5,38,78,.15);
}
.yads-btn:active{transform:translateY(1px)}
.yads-btn:disabled{opacity:.6;cursor:default}
.yads-btn__icon{width:16px;height:16px;stroke:currentColor}

/* mobile */
@media (max-width: 640px){
  .yads-card{
    padding:12px 12px;
    border-radius:16px;
  }
  .yads-cardRow{
    grid-template-columns:40px minmax(0,1fr);
    gap:10px;
  }
  .yads-badge{
    width:34px;
    height:34px;
    font-size:16px;
  }
  .yads-card__title{
    font-size:15px;
  }
  .yads-chip{
    height:26px;
    padding:0 10px;
    font-size:11px;
  }
  .yads-card__msg{
    font-size:13px;
  }
}
`;
        let s = document.getElementById('yads-swal-styles');
        if (s) {
            s.textContent = css;
            return;
        }
        s = document.createElement('style');
        s.id = 'yads-swal-styles';
        s.textContent = css;
        document.head.appendChild(s);
    };



    useEffect(() => {
        if (!flow.active || !flow.wantOnboard) return;

        const onboardDone = !flow.wantOnboard || ['success', 'error'].includes(flow.onboard.status);
        const ingestionDone = ['success', 'error', 'skipped'].includes(flow.ingestion.status);
        if (!onboardDone || !ingestionDone) return;

        ensureYadsSwalStyles();

        const obStatus = flow.wantOnboard ? flow.onboard.status : 'na';
        const igStatus = flow.ingestion.status;
        const igLabel = flow.mode === 'schedule' ? 'Scheduling' : 'Ingestion';

        const chip = (s) => s === 'success' ? 'Succeeded' : s === 'error' ? 'Failed' : s === 'skipped' ? 'Skipped' : 'Not needed';
        const badgeCls = (s) => s === 'success' ? 'success' : s === 'error' ? 'error' : 'warn';
        const iconChar = (s) => s === 'success' ? '✓' : s === 'error' ? '✖' : '!';
        const chipCls = (s) => badgeCls(s);

        // generic row (no retry)
        const row = (label, status, msg) => `
   <div class="yads-card">
    <div class="yads-cardRow">
      <div class="yads-left">
        <span class="yads-badge yads-badge--${badgeCls(status)}">${iconChar(status)}</span>
      </div>
      <div class="yads-right">
        <div class="yads-titleLine">
          <div class="yads-card__title">${yadsEscapeHtml(label)}</div>
          <span class="yads-chip yads-chip--${chipCls(status)}">${chip(status)}</span>
        </div>
        <div class="yads-card__msgWrap">
          <p class="yads-card__msg">${msg ? yadsEscapeHtml(msg) : 'No details available.'}</p>
        </div>
      </div>
    </div>
  </div>
  `;

        // onboarding row with Retry button if failed
        const rowOnboard = (status, msg) => `
  <div class="yads-card">
    <div class="yads-cardRow">
      <div class="yads-left">
        <span class="yads-badge yads-badge--${badgeCls(status)}">${iconChar(status)}</span>
      </div>
      <div class="yads-right">
        <div class="yads-titleLine">
          <div class="yads-card__title">Onboarding</div>
          <span class="yads-chip yads-chip--${chipCls(status)}">${chip(status)}</span>
        </div>
        <div class="yads-card__msgWrap">
          <p class="yads-card__msg">${msg ? yadsEscapeHtml(msg) : 'No details available.'}</p>
        </div>
        ${status === 'error' ? `
          <button id="yads-retry-onboard" class="yads-btn" type="button" aria-label="Retry onboarding">
            <svg viewBox="0 0 24 24" fill="none" class="yads-btn__icon" aria-hidden="true">
              <path d="M21 12a9 9 0 1 1-2.64-6.36M21 4v6h-6"
                    stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Retry
          </button>` : ``}
      </div>
    </div>
  </div>
`;

        const obOverallStatus = flow.onboard?.overall?.status || obStatus;
        const obOverallMsg = flow.onboard?.overall?.msg || flow.onboard?.msg || '';
        const hasStepResponses = !!flow.onboard?.hasStepResponses;

        const isStepStatus = flow.onboard?.isProcess?.status || 'na';
        const isStepMsg = flow.onboard?.isProcess?.msg || '';

        const ctmStepStatus = flow.onboard?.controlM?.status || 'na';
        const ctmStepMsg = flow.onboard?.controlM?.msg || '';

        const obMsg = obStatus === 'na'
            ? 'Onboarding not required for this action.'
            : (obOverallMsg || '');

        const igMsg = igStatus === 'skipped'
            ? (flow.ingestion.msg || 'Not started due to onboarding failure.')
            : (flow.ingestion.msg || '');

        const html = `
  <div class="yads-outcomeGrid">
    ${rowOnboard(obStatus === 'na' ? 'warn' : obOverallStatus, obMsg)}

    ${flow.wantOnboard && hasStepResponses ? row(
            'IS Process Upload',
            isStepStatus === 'na' ? 'warn' : isStepStatus,
            isStepMsg || 'No IS package response.'
        ) : ''}

    ${flow.wantOnboard && hasStepResponses ? row(
            'Control-M Onboarding',
            ctmStepStatus === 'na' ? 'warn' : ctmStepStatus,
            ctmStepMsg || 'No Control-M onboarding response.'
        ) : ''}

    ${row(igLabel, igStatus, igMsg)}
  </div>
`;

        const anyFail = (obStatus === 'error') || (igStatus === 'error');
        const bothFail = (obStatus === 'error') && (igStatus === 'error');
        const iconType = bothFail ? 'error' : anyFail ? 'warning' : 'success';
        const topTitle =
            bothFail ? 'Action failed'
                : anyFail ? 'Completed with issues'
                    : (flow.mode === 'schedule' ? 'Schedule created successfully' : 'Ingestion started successfully');

        Swal.fire({
            icon: iconType,
            title: topTitle,
            html,
            customClass: { popup: 'yads-swal' },
            confirmButtonColor: '#05264e',
            didOpen: (el) => {
                const btn = el.querySelector('#yads-retry-onboard');
                if (!btn) return;

                btn.addEventListener('click', () => {
                    btn.disabled = true;
                    btn.textContent = 'Retrying…';

                    // use last payload; if missing, build a quick fallback from current form
                    const retryPayload = lastOnboardPayloadRef.current || {
                        bhomUrl: newTenant?.tenantUrl || tenantDropdownValue,
                        itsmUrl: newTenant?.itsmUrl || null,
                        key: newTenant?.accessKey,
                        secretKey: newTenant?.secretKey,
                        username: newTenant?.username, // ✅ ITSM username
                        password: newTenant?.password, // ✅ ITSM password
                        adminPassword: ntHannaPwd?.trim() ? ntHannaPwd.trim() : null, // ✅ hannah_admin password
                    };

                    Swal.close(); // close current summary

                    // launch a retry-only flow: onboarding pending, ingestion skipped
                    setFlow({
                        active: true,
                        mode: 'immediate',
                        wantOnboard: true,
                        onboard: {
                            status: 'pending',
                            msg: '',
                            hasStepResponses: false,
                            isProcess: { status: 'na', msg: '' },
                            controlM: { status: 'na', msg: '' },
                            overall: { status: 'na', msg: '' },
                        },
                        ingestion: { status: 'skipped', msg: 'Not started during retry.' },
                    });

                    dispatch(onboardTenant(retryPayload));
                });
            }
        }).then(() => {
            // on normal close (not the inline retry)
            setFlow(FLOW_IDLE);
        });
    }, [flow, dispatch]);




    // ---- time utils (seconds in, string out)
    const clampNum = (n) => (Number.isFinite(Number(n)) ? Number(n) : 0);


    const formatWords = (secsIn) => {
        const s = Math.max(0, Math.floor(clampNum(secsIn)));
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        const r = s % 60;
        if (h) return `${h} hr ${m} min${r ? ` ${r}s` : ""}`;
        if (m) return `${m} min${r ? ` ${r}s` : ""}`;
        return `${r}s`;
    };

    // one place to read ETA seconds off a scenario row
    const etaSecs = (scenario) => clampNum(scenario?.estimatedTime ?? 0);

    // for Reset mode we need to resolve by title
    const etaByTitle = (groupKey, title) => {
        const grp = (scenarioGroups || []).find((g) => g.title === groupKey);
        const sc = grp?.scenarios?.find((s) => s.title === title);
        return clampNum(sc?.estimatedTime ?? 0);
    };


    const getScenarioRunMode = (scenario) => {
        const mode = String(scenario?.runMode ?? "").toLowerCase().trim();

        // Primary source = backend runMode
        if (mode === "duration") return "duration";
        if (mode === "count") return "count";

        // Fallback: if backend provided durationHours, treat it as duration
        if (scenario?.durationHours != null) return "duration";

        return "count";
    };

    const isDurationScenario = (scenario) => getScenarioRunMode(scenario) === "duration";




    const getScenarioValue = (scenario) => {
        if (isDurationScenario(scenario)) {
            return parseInt(scenario?.durationHours, 10) || 1;
        }
        return parseInt(scenario?.count, 10) || 1;
    };

    const buildScenarioLabel = (scenario) => {
        const value = getScenarioValue(scenario);
        return isDurationScenario(scenario)
            ? `${scenario.title} - ${value} hour${value > 1 ? "s" : ""}`
            : `${scenario.title} - ${value}`;
    };



    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(selectedItems);
        const [reordered] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reordered);

        setSelectedItems(items);
    };



    // Scenario Count
    const updateScenarioCount = (index, newValue) => {
        const updated = [...selectedGroupScenarios];
        if (isInitScenario(updated[index])) return;

        const current = updated[index];

        if (isDurationScenario(current)) {
            updated[index].durationHours = newValue;
        } else {
            updated[index].count = newValue;
        }

        setSelectedGroupScenarios(updated);
    };


    const sanitizeScenarioCount = (index, rawValue) => {
        let value = parseInt(rawValue, 10);

        if (isNaN(value) || value <= 0) {
            value = 1;
        }

        const updated = [...selectedGroupScenarios];
        if (isInitScenario(updated[index])) return;

        const current = updated[index];

        if (isDurationScenario(current)) {
            updated[index].durationHours = value;
        } else {
            updated[index].count = value;
        }

        setSelectedGroupScenarios(updated);

        const updatedScenario = updated[index];

        setSelectedItems(prevItems =>
            prevItems.map(item => {
                if (item.id === updatedScenario.id) {
                    return {
                        ...item,
                        group: selectedGroup,
                        label: buildScenarioLabel(updatedScenario),
                    };
                }
                return item;
            })
        );
    };



    const applyAdvancedScenarioSelection = (updatedScenarios, groupKey = selectedGroup) => {
        setSelectedGroupScenarios(updatedScenarios);

        const selectedScenarios = updatedScenarios.filter(s => s.selected);
        const selectedIds = selectedScenarios.map(s => s.id);

        setGroupScenarioSelectionMap(prev => ({
            ...prev,
            [groupKey]: selectedIds,
        }));

        const total = updatedScenarios.length;
        const selectedCount = selectedScenarios.length;
        const checkboxStatus =
            selectedCount === total ? 'checked'
                : selectedCount > 0 ? 'partial'
                    : 'none';

        setGroupCheckboxes(prev => ({
            ...prev,
            [groupKey]: checkboxStatus,
        }));

        const scenarioTags = selectedScenarios.map(s => ({
            id: s.id,
            group: groupKey,
            label: buildScenarioLabel(s),
        }));

        setSelectedItems(scenarioTags);
    };



    const handleScenarioToggle = (scenarioIndex) => {
        const mode = getCurrentMode();
        if (mode === 'Reset') return;

        const updated = [...selectedGroupScenarios];
        const scenario = updated[scenarioIndex];

        // ✅ INIT can be toggled in Advanced now
        scenario.selected = !scenario.selected;

        if (isInitScenario(scenario) && !scenario.selected) {
            setCreateHealthIndicator(false);
        }

        if (mode === 'Advanced') {
            applyAdvancedScenarioSelection(updated);
            return;
        }

        setSelectedGroupScenarios(updated);

        if (mode === 'Advanced') {
            // In-memory map: ONLY currently selected scenarios (no implicit INIT)
            const selectedIds = updated
                .filter(s => s.selected)
                .map(s => s.id);

            setGroupScenarioSelectionMap(prev => ({
                ...prev,
                [selectedGroup]: selectedIds,
            }));
        }

        // Checkbox status for the group
        const total = updated.length;
        const selectedCount = updated.filter(s => s.selected).length;
        const checkboxStatus =
            selectedCount === total ? 'checked'
                : selectedCount > 0 ? 'partial'
                    : 'none';

        setGroupCheckboxes(prev => ({
            ...prev,
            [selectedGroup]: checkboxStatus,
        }));

        // Reflect Advanced selections in the right panel (overwrite this group's tags)
        if (mode === 'Advanced') {
            const scenarioTags = updated
                .filter(s => s.selected) // 👈 no auto-include INIT
                .map(s => ({
                    id: s.id,
                    group: selectedGroup,
                    label: buildScenarioLabel(s),
                }));

            setSelectedItems(scenarioTags); // one-group-at-a-time
        }
    };



    const handleCreateHealthIndicatorToggle = (checked, initScenarioId) => {
        if (!checked) {
            setCreateHealthIndicator(false);
            return;
        }

        setCreateHealthIndicator(true);

        const updated = selectedGroupScenarios.map(s =>
            s.id === initScenarioId ? { ...s, selected: true } : s
        );

        applyAdvancedScenarioSelection(updated);
    };





    const handleSelectAllScenarios = () => {
        // Are ALL scenarios currently selected?
        const allSelected = selectedGroupScenarios.every(s => s.selected);

        // Toggle all -> if all were selected, unselect all; otherwise select all
        const nextSelected = !allSelected;
        const updated = selectedGroupScenarios.map(s => ({
            ...s,
            selected: nextSelected,
        }));

        if (!nextSelected || !updated.some(s => s.selected && isInitScenario(s))) {
            setCreateHealthIndicator(false);
        }

        applyAdvancedScenarioSelection(updated);

        // Checkbox UI state (since we toggle uniformly, it's either 'checked' or 'none')
        // In-memory selection map: ONLY currently selected
        const selectedIds = nextSelected ? updated.map(s => s.id) : [];
        setGroupScenarioSelectionMap(prev => ({
            ...prev,
            [selectedGroup]: selectedIds,
        }));

        // Right panel → overwrite with this group's selected scenarios
        const tags = nextSelected
            ? updated.map(s => ({
                id: s.id,
                group: selectedGroup,
                label: buildScenarioLabel(s),
            }))
            : [];

        setSelectedItems(tags); // one-group-at-a-time
    };




    const restoreGroupScenarios = (group) => {
        const groupKey = group.title;

        // 🔄 Clear previous group's UI/state (one-group-at-a-time)
        setSelectedGroupScenarios([]);
        setSelectedItems([]);
        setGroupScenarioSelectionMap({});
        setGroupCheckboxes({});
        setScenarioModes({});
        setRticReset(false);
        setCreateHealthIndicator(false);

        // ✅ Set current group
        setSelectedGroup(groupKey);

        // 👇 Always start in Default (no persistence)
        setScenarioModes({ [groupKey]: 'Default' });

        console.log("Restoring scenarios for group", group);

        // 📝 Build scenario rows for Default (all selected)
        const groupScenarios = group.scenarios.map(s => ({
            ...s,
            selected: true,
            count: s.count || 1,
            durationHours: s.durationHours || 1,
            estimatedTime: s.estimatedTime == null ? null : Number(s.estimatedTime),
        }));
        setSelectedGroupScenarios(groupScenarios);

        // 🏷️ Right panel → one tag for the group (auto-add on click)
        setSelectedItems([{
            id: `group-${groupKey}`,
            group: groupKey,
            label: groupKey,
        }]);

        // Checkbox state for this group
        setGroupCheckboxes({ [groupKey]: 'checked' });
    };




    const handleRemoveSelectedItem = (idToRemove) => {
        const isGroupTag = idToRemove.startsWith("group-");
        const groupKey = isGroupTag ? idToRemove.replace("group-", "") : null;

        if (isGroupTag) {
            // Remove this group's items from the right panel completely
            setSelectedItems(prev => prev.filter(item => item.group !== groupKey));

            if (selectedGroup === groupKey) {
                // Deselect all scenarios for the current group (INIT is NOT mandatory)
                const updated = selectedGroupScenarios.map(s => ({ ...s, selected: false }));
                setSelectedGroupScenarios(updated);
                setCreateHealthIndicator(false);

                // Checkbox UI + selection map for this group
                setGroupCheckboxes(prev => ({ ...prev, [groupKey]: 'none' }));
                setGroupScenarioSelectionMap(prev => {
                    const next = { ...prev };
                    delete next[groupKey]; // or: next[groupKey] = [];
                    return next;
                });
            } else {
                // If removing some other group's tag, just clear its entry in the map
                setGroupScenarioSelectionMap(prev => {
                    const next = { ...prev };
                    delete next[groupKey];
                    return next;
                });
            }

            return; // done handling group removal
        }

        const removedScenario = selectedGroupScenarios.find(s => s.id === idToRemove);
        if (isInitScenario(removedScenario)) {
            setCreateHealthIndicator(false);
        }

        // Remove individual scenario tag from the right panel
        setSelectedItems(prev => prev.filter(item => item.id !== idToRemove));

        // Deselect that scenario in the current group's list and update UI + map
        setSelectedGroupScenarios(prev => {
            const updated = prev.map(s =>
                s.id === idToRemove ? { ...s, selected: false } : s
            );

            const total = updated.length;
            const selectedCount = updated.filter(s => s.selected).length;
            const status =
                selectedCount === 0 ? 'none' :
                    selectedCount === total ? 'checked' :
                        'partial';

            setGroupCheckboxes(prevChk => ({ ...prevChk, [selectedGroup]: status }));

            const ids = updated.filter(s => s.selected).map(s => s.id);
            setGroupScenarioSelectionMap(prevMap => ({ ...prevMap, [selectedGroup]: ids }));

            return updated;
        });
    };




    const handleStartIngestion = () => {
        // ✅ Step 1: Basic validation
        if (selectedItems.length === 0) {
            alert("Please select at least one scenario or group.");
            return;
        }

        const mode = getCurrentMode();

        // ⚠️ Advanced mode: warn if group has *-Init but none selected
        if (mode === 'Advanced' && selectedGroup) {
            const groupObj = scenarioGroups.find(g => g.title === selectedGroup);
            const initTitles = (groupObj?.scenarios || [])
                .filter(isInitScenario)
                .map(s => s.title);

            const hasInitInGroup = initTitles.length > 0;
            const userSelectedInit = selectedGroupScenarios.some(
                s => s.selected && isInitScenario(s)
            );

            if (hasInitInGroup && !userSelectedInit) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Proceed without Init?',
                    html: `You have not selected an Init scenario for <b>${selectedGroup}</b>${initTitles.length ? ` (${initTitles.join(', ')})` : ''
                        }. <br/>Do you want to continue without Init?`,
                    showCancelButton: true,
                    confirmButtonText: 'Proceed without Init',
                    cancelButtonText: 'Go back',
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#05264e',
                }).then(res => {
                    if (res.isConfirmed) {
                        proceedWithIngestion();
                    }
                });
                return; // stop here; only proceed if user confirms
            }
        }

        // ✅ Normal confirmation flow
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to proceed with this ingestion?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#05264e',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Proceed',
        }).then((result) => {
            if (result.isConfirmed) {
                proceedWithIngestion();
            }
        });
    };




    const escapeRegExp = (s = '') => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // Accepts "Apex-Mobile-Cleanup", "Apex-Mobile Cleanup", "Apex Mobile Cleanup-CRQ", etc.
    const cleanupMatcher = (groupKey) =>
        new RegExp(`^${escapeRegExp(groupKey)}(?:[\\s-]*)Cleanup(?:$|[\\s-])`, 'i');

    // Finds ALL cleanup variants for a group (from that group’s scenarios)
    const findGroupCleanups = (groupKey) => {
        const group = (Array.isArray(scenarioGroups) ? scenarioGroups : []).find(g => g?.title === groupKey);
        if (!group) return [];
        const re = cleanupMatcher(groupKey);
        return (group.scenarios || [])
            .map(s => s.title?.trim())
            .filter(Boolean)
            .filter(title => re.test(title));
    };

    // Last-resort parse if item.group is missing: try from id or label
    const deriveGroupFromItem = (item) => {
        if (item?.group) return item.group;
        if (typeof item?.id === 'string') {
            // strip everything from "Cleanup" onwards (handles "-Cleanup" or " Cleanup")
            const m = item.id.replace(/(?:\s|-)*Cleanup(?:-.*)?$/i, '').trim();
            if (m) return m;
        }
        if (typeof item?.label === 'string') {
            const m = item.label.replace(/(?:\s|-)*Cleanup(?:-.*)?$/i, '').trim();
            if (m) return m;
        }
        return null;
    };

    // helper (top of the file or inside the component)
    const swalWarn = (text, title = "Hold on") =>
        Swal.fire({
            icon: "warning",
            title,
            text,
            confirmButtonColor: "#05264e",
        });

    const disableCreateHealthIndicatorForScheduling = () => {
        if (!createHealthIndicator) return;
        setCreateHealthIndicator(false);
    };

    const computeResetRtic = () => (getCurrentMode() === 'Reset' ? !!rticReset : false);

    const handleCloseSchedule = () => {
        setShowSchedule(false);
        setShowHealthIndicatorSchedulingWarning(false);
    };

    const handleOpenSchedule = () => {
        if (createHealthIndicator) {
            setShowHealthIndicatorSchedulingWarning(true);
            setCreateHealthIndicator(false);
        } else {
            setShowHealthIndicatorSchedulingWarning(false);
        }
        setShowSchedule(true);
    };

    const proceedWithIngestion = async () => {
        // ✅ Step 1: Validate
        if (selectedItems.length === 0) {
            await swalWarn("Please select at least one scenario or group.");
            return;
        }

        let tenantData = {};

        if (useNewTenant) {
            const { tenantUrl, secretKey, accessKey, username, password, itsmUrl } = newTenant;

            if (!tenantUrl || !secretKey || !accessKey || !username || !password) {
                await swalWarn("Please fill all new tenant fields.", "Incomplete tenant details");
                return;
            }

            tenantData = {
                tenantUrl,
                itsmUrl,
                key: accessKey,
                secretKey,
                username,
                password,
            };
        } else if (!tenantOptions?.length) {
            // No tenants came from API
            await swalWarn("No tenants available. Please add a new tenant.");
            setUseNewTenant(true);               // optional: auto-switch to New Tenant form
            return;
        } else if (!tenantDropdownValue) {
            // Tenants exist but nothing selected (rare, but safe)
            await swalWarn("Please select a tenant or add a new one.");
            return;
        } else {

            const matched = tenantOptions.find(
                (t) => t.tenantUrl === tenantDropdownValue
            );

            if (!matched) {
                await swalWarn("Selected tenant not found.");
                return;
            }

            tenantData = {
                tenantUrl: matched.tenantUrl,
                itsmUrl: matched.itsmUrl,
                key: matched.key,
                secretKey: matched.secretKey,
                username: matched.username,
                password: matched.password,
            };
        }

        // ✅ Step 2: Prepare scenarios
        const scenarioSet = new Set();
        const scenariosPayload = [];

        selectedItems.forEach((item) => {


            // ✅ 1) Handle RESET items
            // ✅ 1) Handle RESET items — collect ALL cleanup variants (tolerant spacing/dashes)
            if (item?.type === 'reset' || (typeof item?.id === 'string' && item.id.startsWith('reset-'))) {
                const groupKey = deriveGroupFromItem(item);
                if (groupKey) {
                    // get titles from this group's scenarios that look like "<groupKey> Cleanup*" or "<groupKey>-Cleanup*"
                    let titles = findGroupCleanups(groupKey);

                    // Safety fallback: scan all scenario titles if group array not yet loaded
                    if (!titles.length) {
                        const allTitles = (Array.isArray(scenarioGroups) ? scenarioGroups : [])
                            .flatMap(g => (g.scenarios || []).map(s => s.title?.trim()))
                            .filter(Boolean);
                        const re = cleanupMatcher(groupKey);
                        titles = allTitles.filter(t => re.test(t));
                    }

                    // Push all cleanup variants once
                    titles.forEach((title) => {
                        if (!scenarioSet.has(title)) {
                            scenarioSet.add(title);
                            scenariosPayload.push({ type: 'scenario', title, count: 1 });
                        }
                    });
                }
                return; // move to next item
            }

            if (item.id.startsWith("group-")) {
                scenariosPayload.push({
                    type: "group",
                    title: item.label,
                    count: 1, // default to 1 for group
                });
            } else if (!scenarioSet.has(item.id)) {
                const scenario = scenarioGroups
                    .flatMap((g) => g.scenarios)
                    .find((s) => s.id === item.id);

                if (scenario) {
                    scenarioSet.add(scenario.id);
                    const selectedScenario =
                        selectedGroupScenarios.find((s) => s.id === item.id) ||
                        scenarioGroups.flatMap((g) => g.scenarios).find((s) => s.id === item.id);

                    if (selectedScenario) {
                        const payloadScenario = {
                            type: "scenario",
                            title: selectedScenario.title,
                        };

                        if (isDurationScenario(selectedScenario)) {
                            payloadScenario.durationHours = parseInt(selectedScenario.durationHours, 10) || 1;
                        } else {
                            payloadScenario.count = parseInt(selectedScenario.count, 10) || 1;
                        }

                        scenariosPayload.push(payloadScenario);
                    }
                }
            }
        });

        // ✅ Final Payload
        const finalPayload = {
            ...tenantData,
            scenarios: scenariosPayload,
            resetRticCluster: computeResetRtic(),
            createHealthIndicator: Boolean(createHealthIndicator),
        };


        console.log("🚀 Final Payload:", finalPayload);

        const wantOnboard = !!(useNewTenant && ntOnboardOptIn);
        if (wantOnboard) {
            // coordinate a single “final” popup
            setFlow({
                active: true,
                mode: 'immediate',
                wantOnboard: true,
                onboard: {
                    status: 'pending',
                    msg: '',
                    hasStepResponses: false,
                    isProcess: { status: 'na', msg: '' },
                    controlM: { status: 'na', msg: '' },
                    overall: { status: 'na', msg: '' },
                },
                ingestion: { status: 'pending', msg: '' },
            });
            const ok = await callOnboardingIfNeeded();
            if (!ok) return; // abort ingestion if onboarding failed
        }
        // if !wantOnboard, we fall through to normal ingestion and normal toasts


        // ...after you compute finalPayload
        dispatch(startYadsIngestion(finalPayload));
        dispatch(getYadsPollingStatus());
        dispatch(getTenantScenarios());
    };



    const handleScenarioModeChange = (mode, customGroupKey) => {
        const groupKey = customGroupKey || selectedGroup;
        if (!groupKey) return;

        // if leaving Reset, clear the flag
        if (mode !== 'Reset') {
            setRticReset(false);
        }

        if (mode !== 'Advanced') {
            setCreateHealthIndicator(false);
        }

        // In-memory only (no localStorage)
        setScenarioModes(prev => ({ ...prev, [groupKey]: mode }));

        const groupObj = scenarioGroups.find(g => g.title === groupKey);
        if (!groupObj) return;

        if (mode === 'Default') {
            // All scenarios selected
            const groupScenarios = groupObj.scenarios.map(s => ({
                ...s,
                selected: true,
                count: s.count || 1,
                durationHours: s.durationHours || 1,
                estimatedTime: s.estimatedTime == null ? null : Number(s.estimatedTime),
            }));
            setSelectedGroupScenarios(groupScenarios);

            // Right panel → ONLY this group's tag (overwrite)
            setSelectedItems([{
                id: `group-${groupKey}`,
                group: groupKey,
                label: groupKey,
            }]);

            // Checkbox UI
            setGroupCheckboxes(prev => ({ ...prev, [groupKey]: 'checked' }));
        }

        else if (mode === 'Advanced') {
            // By default: select only INIT; others unselected
            const updatedScenarios = groupObj.scenarios.map(scenario => {
                console.log('Scenario:', scenario);
                return {
                    ...scenario,
                    selected: false,
                    count: scenario.count || 1,
                    durationHours: scenario.durationHours || 1,
                    estimatedTime: scenario.estimatedTime == null ? null : Number(scenario.estimatedTime),
                };
            });
            setSelectedGroupScenarios(updatedScenarios);

            // In-memory selection map for this session
            const enforcedIds = updatedScenarios
                .filter(s => s.selected)
                .map(s => s.id);
            setGroupScenarioSelectionMap(prev => ({ ...prev, [groupKey]: enforcedIds }));

            // Right panel → ONLY this group's selected scenarios (overwrite)
            const scenarioTags = updatedScenarios
                .filter(s => s.selected)
                .map(s => ({
                    id: s.id,
                    group: groupKey,
                    label: buildScenarioLabel(s),
                }));
            setSelectedItems(scenarioTags);

            // Checkbox UI state
            const total = updatedScenarios.length;
            const selectedCount = updatedScenarios.filter(s => s.selected).length;
            setGroupCheckboxes(prev => ({
                ...prev,
                [groupKey]:
                    selectedCount === 0 ? 'none'
                        : selectedCount === total ? 'checked'
                            : 'partial',
            }));
        }

        else if (mode === 'Reset') {
            // Reset removes normal scenarios
            setSelectedGroupScenarios([]);

            // Use helper to find ALL cleanup variants for this group
            const cleanupTitles = findGroupCleanups(groupKey);

            // Build tags for right panel
            const cleanupTags = cleanupTitles.map(title => {
                const scenario = groupObj.scenarios.find(s => s.title === title);
                return {
                    id: scenario?.id || title,   // prefer real id if present
                    type: 'scenario',
                    group: groupKey,
                    label: `${title} - 1`,
                };
            });

            // If no cleanup variants found, fall back to single pseudo tag
            setSelectedItems(
                cleanupTags.length > 0
                    ? cleanupTags
                    : [{
                        id: `reset-${groupKey}`,
                        type: 'reset',
                        group: groupKey,
                        label: `${groupKey} Cleanup`,
                    }]
            );

            // Checkbox UI
            setGroupCheckboxes(prev => ({ ...prev, [groupKey]: 'none' }));

            // Clear stored selection for this group
            setGroupScenarioSelectionMap(prev => {
                const next = { ...prev };
                delete next[groupKey];
                return next;
            });
        }
    };






    useEffect(() => {
        if (selectAllRef.current) {
            selectAllRef.current.indeterminate = getAdvancedSelectionState() === 'some';
        }
    }, [selectedGroup, selectedGroupScenarios, scenarioModes]);


    const handleTenantChange = (e) => {
        const value = e.target.value;
        setTenantInput(value);
        setNewTenant((prev) => ({ ...prev, tenantUrl: value }));
    };

    const handleItsmChange = (e) => {
        const value = e.target.value;
        setItsmInput(value);
        setNewTenant((prev) => ({ ...prev, itsmUrl: value }));
    };

    const getAdvancedSelectionState = () => {
        if (!selectedGroupScenarios.length) return 'none';
        const selectedCount = selectedGroupScenarios.filter(s => s.selected).length;
        if (selectedCount === 0) return 'none';
        if (selectedCount === selectedGroupScenarios.length) return 'all';
        return 'some';
    };


    const resetNewTenantForm = () => {
        setTenantInput("");
        setItsmInput("");
        setNewTenant({
            tenantUrl: "",
            secretKey: "",
            accessKey: "",
            username: "",
            password: "",
            itsmUrl: "",
        });
        setNtOnboardOptIn(false);
        setNtHannaPwd("");
    };


    // Edit Tenant Modal helpers
    const handleEditExistingTenant = () => {
        if (!selectedTenant) {
            Swal.fire("No tenant selected", "Pick a tenant first.", "warning");
            return;
        }

        // 🚫 NEW: block edits for shared tenants
        if (selectedTenant.type === 'shared') {
            Swal.fire(
                "Shared tenant",
                "You cannot edit details for a shared tenant. Please use your own tenant if you need custom credentials.",
                "info"
            );
            return;
        }

        // Prepare editable copy for the modal
        setTenantEditDraft({
            id: selectedTenant._id || selectedTenant.id || selectedTenant.tenantId, // adjust to your backend
            tenantUrl: selectedTenant.tenantUrl || "",
            itsmUrl: selectedTenant.itsmUrl || "",
            accessKey: selectedTenant.key || "",
            secretKey: selectedTenant.secretKey || "",
            username: selectedTenant.username || "",
            password: selectedTenant.password || "",
        });

        setIsTenantEditOpen(true);
    };



    const toggleNewTenantMode = () => {
        if (useNewTenant) {
            // going back to existing tenant dropdown
            setUseNewTenant(false);

            resetNewTenantForm(); // optional, but keeps state clean
        } else {
            // entering new-tenant mode from normal flow
            setUseNewTenant(true);
            resetNewTenantForm(); // 👈 blank form for true new tenant
        }
    };





    const buildScenariosPayloadFromSelectedItems = () => {
        const scenarioSet = new Set();
        const scenariosPayload = [];

        const escapeRegExp = (s = '') => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const cleanupMatcher = (groupKey) =>
            new RegExp(`^${escapeRegExp(groupKey)}(?:[\\s-]*)Cleanup(?:$|[\\s-])`, 'i');
        const findGroupCleanups = (groupKey) => {
            const group = (Array.isArray(scenarioGroups) ? scenarioGroups : []).find(g => g?.title === groupKey);
            if (!group) return [];
            const re = cleanupMatcher(groupKey);
            return (group.scenarios || [])
                .map(s => s.title?.trim())
                .filter(Boolean)
                .filter(title => re.test(title));
        };
        const deriveGroupFromItem = (item) => {
            if (item?.group) return item.group;
            if (typeof item?.id === 'string') {
                const m = item.id.replace(/(?:\s|-)*Cleanup(?:-.*)?$/i, '').trim();
                if (m) return m;
            }
            if (typeof item?.label === 'string') {
                const m = item.label.replace(/(?:\s|-)*Cleanup(?:-.*)?$/i, '').trim();
                if (m) return m;
            }
            return null;
        };

        selectedItems.forEach((item) => {
            // reset/cleanup case
            if (item?.type === 'reset' || (typeof item?.id === 'string' && item.id.startsWith('reset-'))) {
                const groupKey = deriveGroupFromItem(item);
                if (groupKey) {
                    let titles = findGroupCleanups(groupKey);
                    if (!titles.length) {
                        const allTitles = (Array.isArray(scenarioGroups) ? scenarioGroups : [])
                            .flatMap(g => (g.scenarios || []).map(s => s.title?.trim()))
                            .filter(Boolean);
                        const re = cleanupMatcher(groupKey);
                        titles = allTitles.filter(t => re.test(t));
                    }
                    titles.forEach((title) => {
                        if (!scenarioSet.has(title)) {
                            scenarioSet.add(title);
                            scenariosPayload.push({ type: 'scenario', title, count: 1 });
                        }
                    });
                }
                return;
            }

            if (item.id.startsWith("group-")) {
                scenariosPayload.push({ type: "group", title: item.label, count: 1 });
            } else if (!scenarioSet.has(item.id)) {
                const scenario = scenarioGroups
                    .flatMap((g) => g.scenarios)
                    .find((s) => s.id === item.id);

                if (scenario) {
                    scenarioSet.add(scenario.id);
                    const selectedScenario =
                        selectedGroupScenarios.find((s) => s.id === item.id) ||
                        scenarioGroups.flatMap((g) => g.scenarios).find((s) => s.id === item.id);

                    if (selectedScenario) {
                        const payloadScenario = {
                            type: "scenario",
                            title: selectedScenario.title,
                        };

                        if (isDurationScenario(selectedScenario)) {
                            payloadScenario.durationHours = parseInt(selectedScenario.durationHours, 10) || 1;
                        } else {
                            payloadScenario.count = parseInt(selectedScenario.count, 10) || 1;
                        }

                        scenariosPayload.push(payloadScenario);
                    }
                }
            }
        });

        return scenariosPayload;
    };



    // helper to get tenant creds from get-scenarios response
    const getTenantCredByUrl = (tenantUrl) => {
        console.log("Looking up tenant credentials for:", tenantUrl);
        const t = (tenantOptions || []).find(t => t.tenantUrl === tenantUrl);
        if (!t) return null;
        return {
            tenantUrl: t.tenantUrl,
            itsmUrl: t.itsmUrl,
            key: t.key,
            secretKey: t.secretKey,
            username: t.username,
            password: t.password,
        };
    };



    const handleCancelSchedule = (row) => {
        console.log("Cancel schedule clicked for row:", row);
        // row.tenant is the tenantUrl, row.id is taskId (you constructed it from taskId)
        const tenantPayload = getTenantCredByUrl(row.tenant);

        if (!tenantPayload) {
            Swal.fire(
                "Missing Tenant Details",
                "Could not find credentials for this tenant in the scenario data. Please refresh data.",
                "warning"
            );
            return;
        }

        Swal.fire({
            title: 'Cancel this schedule?',
            text: `Tenant: ${row.tenant}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#05264e',
            confirmButtonText: 'Yes, Cancel',
        }).then(res => {
            if (res.isConfirmed) {
                dispatch(cancelYadsScheduledIngestion(row.id, tenantPayload));
            }
        });
    };



    // When user clicks Edit in the bar
    // open
    const handleEditSchedule = (row) => {
        // row has { id, tenant, scenarios, scheduledFor, _raw }
        setEditingRecord(row?._raw || row);     // prefer the raw schedule shape
        setEditOpen(true);
    };





    // Recurring schedule functions
    const handleDeleteRecurringSchedule = (row) => {
        console.log("Cancel schedule clicked for row:", row);
        // row.tenant is the tenantUrl, row.id is taskId (you constructed it from taskId)
        const tenantPayload = getTenantCredByUrl(row.tenant);

        if (!tenantPayload) {
            Swal.fire(
                "Missing Tenant Details",
                "Could not find credentials for this tenant in the scenario data. Please refresh data.",
                "warning"
            );
            return;
        }

        Swal.fire({
            title: 'Cancel this schedule?',
            text: `Tenant: ${row.tenant}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#05264e',
            confirmButtonText: 'Yes, Cancel',
        }).then(res => {
            if (res.isConfirmed) {
                dispatch(cancelYadsRecurringScheduleIngestion(row.id, tenantPayload));
            }
        });
    };




    const handleEditRecurringSchedule = (row) => {
        const raw = row?._raw || row;   // prefer backend shape
        setEditingRecordRecurring(raw);
        setEditOpenRecurring(true);
    };


    // ✅ Build criteria **only** from API fields (no defaults, no local fallbacks)
    function buildCriteriaForToggle(rowOrRaw) {
        const raw = rowOrRaw?._raw || rowOrRaw;

        // 1) If backend ever sends scheduleCriteria back, prefer that
        if (raw?.scheduleCriteria?.time && raw?.scheduleCriteria?.timezone) {
            return {
                type: raw.scheduleCriteria.type,
                days: Array.isArray(raw.scheduleCriteria.days)
                    ? [...raw.scheduleCriteria.days]
                    : [],
                time: raw.scheduleCriteria.time,
                timezone: normalizeTimezone(raw.scheduleCriteria.timezone),
            };
        }

        // 2) If scheduledTime is already an object { time, timezone }, handle that too
        if (raw?.scheduledTime && typeof raw.scheduledTime === 'object') {
            return {
                type: raw?.frequency?.type,
                days: Array.isArray(raw?.frequency?.days)
                    ? raw.frequency.days.slice()
                    : [],
                time: raw.scheduledTime.time,
                timezone: normalizeTimezone(raw.scheduledTime.timezone),
            };
        }

        // 3) Current case: scheduledTime is an ISO string "2025-11-25T10:40:00Z"
        let time;
        let timezone;

        if (typeof raw?.scheduledTime === 'string') {
            try {
                const d = new Date(raw.scheduledTime);
                if (!Number.isNaN(d.getTime())) {
                    const hh = String(d.getUTCHours()).padStart(2, '0');
                    const mm = String(d.getUTCMinutes()).padStart(2, '0');

                    // ✅ interpret it as a UTC clock time
                    time = `${hh}:${mm}`;
                    timezone = 'UTC';
                }
            } catch (e) {
                console.error('Failed to derive time from scheduledTime ISO', raw.scheduledTime, e);
            }
        }

        return {
            type: raw?.frequency?.type, // "weekly"
            days: Array.isArray(raw?.frequency?.days)
                ? raw.frequency.days.slice()
                : [],
            time,
            timezone,
        };
    }

    const handleToggleRecurring = async (row) => {
        const raw = row?._raw || row;

        const taskId = raw?.scheduleId;
        if (!taskId) {
            await Swal.fire("Missing id", "scheduleId not found on this row.", "error");
            return;
        }

        const nextEnabled = !row.enabled;

        const { isConfirmed } = await Swal.fire({
            icon: 'question',
            title: nextEnabled ? 'Enable schedule?' : 'Disable schedule?',
            text: `${row.tenant} will be ${nextEnabled ? 'enabled' : 'disabled'}.`,
            showCancelButton: true,
            confirmButtonText: nextEnabled ? 'Enable' : 'Disable',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#05264e',
        });
        if (!isConfirmed) return;

        // ✅ build criteria safely from the row
        const criteria = buildCriteriaForToggle(row);

        if (!criteria.time || !criteria.timezone) {
            // Failsafe so you don’t keep spamming the API with bad payloads
            await Swal.fire({
                icon: 'error',
                title: 'Cannot toggle this schedule',
                text: 'Missing time/timezone on this schedule. Please edit and save it once, then try again.',
                confirmButtonColor: '#05264e',
            });
            return;
        }

        const payload = {
            scheduleCriteria: {
                ...criteria,
                enabled: nextEnabled,
            },
        };

        console.log("PATCH enable/disable ➜", { taskId, payload });
        dispatch(editYadsRecurringSchedule(taskId, payload));
    };






    // Build (or reuse) the last onboarding payload for retries
    const buildOnboardRetryPayload = () => {
        // 1) Prefer the last payload actually used
        if (lastOnboardPayloadRef.current) return lastOnboardPayloadRef.current;

        // 2) Build from new-tenant form
        if (useNewTenant) {
            const { tenantUrl, itsmUrl, accessKey, secretKey, username, password } = newTenant || {};
            if (!tenantUrl || !accessKey || !secretKey || !username || !password) return null;

            return {
                bhomUrl: tenantUrl,
                itsmUrl: itsmUrl || null,
                key: accessKey,
                secretKey,
                username, // ✅ ITSM username
                password, // ✅ ITSM password
                adminPassword: ntHannaPwd?.trim() ? ntHannaPwd.trim() : null, // ✅ hannah_admin password
            };
        }

        // 3) Fallback to selected existing tenant (if ever needed)
        const matched = (tenantOptions || []).find(t => t.tenantUrl === tenantDropdownValue);
        if (!matched) return null;

        return {
            bhomUrl: matched.tenantUrl,
            itsmUrl: matched.itsmUrl || null,
            key: matched.key,
            secretKey: matched.secretKey,
            username: matched.username, // ✅
            password: matched.password, // ✅
            adminPassword: null,        // collect separately if needed
        };
    };

    // SweetAlert with Retry + Cancel, left-aligned text, multi-retry enabled
    const showRetryableOnboardError = (msg) => {
        Swal.fire({
            icon: 'error',
            title: 'Onboarding failed',
            html: `<p class="swal-msg-center">${yadsEscapeHtml(msg || 'Unknown error')}</p>`,
            showCancelButton: true,
            confirmButtonText: 'Retry',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            confirmButtonColor: '#05264e',
            customClass: { popup: 'swal-center' },
        }).then(res => {
            if (!res.isConfirmed) return;

            const retryPayload = buildOnboardRetryPayload();
            if (!retryPayload?.bhomUrl || !retryPayload?.key || !retryPayload?.secretKey) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Missing details',
                    text: 'Please complete the tenant details before retrying onboarding.'
                });
                return;
            }

            lastOnboardPayloadRef.current = retryPayload;      // keep it for next retry too
            dispatch(onboardTenant(retryPayload));             // 🔁 if this fails again, the same dialog will reappear
        });
    };



    const getStepMessage = (value, fallback = '') => {
        if (!value) return '';

        if (typeof value === 'string') {
            return value.trim();
        }

        if (typeof value === 'object') {
            const values = Object.values(value || {}).filter(Boolean).map(String);
            const keys = Object.keys(value || {}).filter(Boolean).map(String);

            if (values.length) return values.join(' | ');
            if (keys.length) return keys.join(' | ');

            try {
                return JSON.stringify(value);
            } catch {
                return fallback;
            }
        }

        return String(value);
    };

    const inferStepStatus = (msg = '') => {
        const m = String(msg || '').toLowerCase();

        if (/success|successfully|already onboarded|already exists|completed/.test(m)) return 'success';
        if (/fail|failed|error|unable|invalid|denied|incomplete|missing field/.test(m)) return 'error';
        return msg ? 'warn' : 'na';
    };

    const parseOnboardFlowResponse = (raw = {}, fallbackMode = 'success') => {
        // plain string => pre-step normal API response
        if (typeof raw === 'string') {
            const text = raw.trim();
            const status = fallbackMode === 'error' ? 'error' : 'success';

            return {
                status,
                msg: text,
                hasStepResponses: false,
                isProcess: { status: 'na', msg: '' },
                controlM: { status: 'na', msg: '' },
                overall: {
                    status,
                    msg: text || (status === 'error' ? 'Onboarding failed.' : 'Tenant onboarding triggered successfully.'),
                },
            };
        }

        const importMsg = getStepMessage(raw?.['import-is-package-result'], '');
        const controlMMsg = getStepMessage(raw?.['onboard-tenant-result'], '');

        const hasStepResponses = !!(importMsg || controlMMsg);

        const overallMsg =
            (typeof raw?.error === 'string' && raw.error.trim()) ||
            (typeof raw?.success === 'string' && raw.success.trim()) ||
            (typeof raw?.message === 'string' && raw.message.trim()) ||
            '';

        // ✅ pre-step error/success = normal API response only
        if (!hasStepResponses) {
            const overallStatus =
                fallbackMode === 'error'
                    ? 'error'
                    : (raw?.error ? 'error' : 'success');

            const finalMsg =
                overallMsg ||
                (overallStatus === 'error'
                    ? 'Onboarding failed.'
                    : 'Tenant onboarding triggered successfully.');

            return {
                status: overallStatus,
                msg: finalMsg,
                hasStepResponses: false,
                isProcess: { status: 'na', msg: '' },
                controlM: { status: 'na', msg: '' },
                overall: {
                    status: overallStatus,
                    msg: finalMsg,
                },
            };
        }

        // ✅ post-step response = show per-step statuses
        const isStatus = inferStepStatus(importMsg);
        const ctmStatus = inferStepStatus(controlMMsg);

        const overallStatus =
            raw?.error
                ? 'error'
                : raw?.success
                    ? 'success'
                    : fallbackMode === 'error'
                        ? 'error'
                        : 'success';

        const finalStatus =
            overallStatus === 'error' || isStatus === 'error' || ctmStatus === 'error'
                ? 'error'
                : 'success';

        return {
            status: finalStatus,
            msg: overallMsg || (finalStatus === 'error' ? 'Onboarding incomplete.' : 'Successfully onboarded tenant.'),
            hasStepResponses: true,
            isProcess: {
                status: isStatus,
                msg: importMsg || 'No IS package response.',
            },
            controlM: {
                status: ctmStatus,
                msg: controlMMsg || 'No Control-M onboarding response.',
            },
            overall: {
                status: overallStatus,
                msg: overallMsg || (finalStatus === 'error' ? 'Onboarding incomplete.' : 'Successfully onboarded tenant.'),
            },
        };
    };


    // helper: call onboarding first (only for new-tenant + opt-in)
    const callOnboardingIfNeeded = async () => {
        if (!useNewTenant || !ntOnboardOptIn) return true;

        const { tenantUrl, itsmUrl, accessKey, secretKey, username, password } = newTenant || {};
        if (!tenantUrl || !accessKey || !secretKey || !username || !password) return true;

        const payload = {
            bhomUrl: tenantUrl,
            itsmUrl: itsmUrl || null,
            key: accessKey,
            secretKey,
            username,
            password,
            adminPassword: ntHannaPwd?.trim() ? ntHannaPwd.trim() : null,
        };

        lastOnboardPayloadRef.current = payload;

        try {
            supressOnboardToastRef.current = true;
            await dispatch(onboardTenant(payload));
            setNtHannaPwd('');
            return true;
        } catch (err) {
            const parsed = parseOnboardFlowResponse(err, 'error');

            setFlow(prev => prev.active ? {
                ...prev,
                onboard: parsed,
                ingestion: { status: 'skipped', msg: 'Not started due to onboarding failure.' },
            } : prev);

            return false;
        } finally {
            setTimeout(() => (supressOnboardToastRef.current = false), 0);
        }
    };


    const handleConfirmSchedule = async ({ dateStr, timeStr, isoStart }) => {
        disableCreateHealthIndicatorForScheduling();

        // Build tenantData exactly like proceedWithIngestion()
        let tenantData = {};
        if (useNewTenant) {
            const { tenantUrl, secretKey, accessKey, username, password, itsmUrl } = newTenant;
            if (!tenantUrl || !secretKey || !accessKey || !username || !password) {
                Swal.fire("Incomplete tenant details", "Please fill all new tenant fields.", "warning");
                return;
            }
            tenantData = { tenantUrl, itsmUrl, key: accessKey, secretKey, username, password };
        } else {
            const matched = tenantOptions.find(t => t.tenantUrl === tenantDropdownValue);
            if (!matched) {
                Swal.fire("Tenant missing", "Please select a tenant or add a new one.", "warning");
                return;
            }
            tenantData = {
                tenantUrl: matched.tenantUrl,
                itsmUrl: matched.itsmUrl,
                key: matched.key,
                secretKey: matched.secretKey,
                username: matched.username,
                password: matched.password,
            };
        }

        const scenariosPayload = buildScenariosPayloadFromSelectedItems();
        if (!scenariosPayload.length) {
            Swal.fire("No scenarios", "Please select at least one scenario or group.", "warning");
            return;
        }

        const finalPayload = {
            ...tenantData,
            scenarios: scenariosPayload,
            scheduledTime: isoStart,        // 👈 IMPORTANT
            resetRticCluster: computeResetRtic(),
        };

        console.log(finalPayload)

        const wantOnboard = !!(useNewTenant && ntOnboardOptIn);
        if (wantOnboard) {
            setFlow({
                active: true,
                mode: 'schedule',
                wantOnboard: true,
                onboard: {
                    status: 'pending',
                    msg: '',
                    hasStepResponses: false,
                    isProcess: { status: 'na', msg: '' },
                    controlM: { status: 'na', msg: '' },
                    overall: { status: 'na', msg: '' },
                },
                ingestion: { status: 'pending', msg: '' }, // scheduling
            });
            const ok = await callOnboardingIfNeeded();
            if (!ok) return;
        }
        // if !wantOnboard, proceed normally and your existing schedule useEffect shows standard toast

        dispatch(startYadsScheduleIngestion(finalPayload));

    };


    const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';


    const handleConfirmRecurringSchedule = ({ frequency, daysOfWeek, time, end }) => {
        disableCreateHealthIndicatorForScheduling();

        const common = getTenantAndScenarios();
        if (!common) return;
        const { tenantData, scenariosPayload } = common;

        // per your requirement: type must be "weekly" and send the selected days (full names)
        const days = (daysOfWeek || []).map(c => DAY_CODE_TO_FULL[c]).filter(Boolean);
        const timezone = normalizeTimezone(BROWSER_TZ); // keep as provided in your spec
        const timeStr24 = to24hStr(time?.hour, time?.minute, time?.ampm || "AM");

        const recurringPayload = {
            ...tenantData,
            scenarios: scenariosPayload,
            scheduleCriteria: {
                type: "weekly",
                days,            // ["Monday", ...]
                time: timeStr24, // "HH:MM"
                timezone,        // "Asia/Singapore"
            },
            ...(end?.type === "byDate" && end?.date ? { endDate: end.date } : {}),
        };

        dispatch(startYadsRecurringScheduleIngestion(recurringPayload));
    };



    // --- ETA split helpers ---
    const isValidPosInt = (v) => {
        const n = parseInt(v, 10);
        return Number.isFinite(n) && n > 0 ? n : 0;
    };

    // seconds contributed by a COUNT-mode scenario (foreground ingestion)
    const countModeContributionSecs = (s) => {
        const runs = isValidPosInt(s?.count) || 1;
        return etaSecs(s) * runs;
    };

    // hours contributed by a DURATION-mode scenario (HighMetric/background)
    const durationModeHours = (s) => {
        const hrs = isValidPosInt(s?.durationHours) || 1;
        return hrs;
    };

    // Format "2h", "1h" etc (keep it compact)
    const formatHoursCompact = (hrs) => {
        const h = isValidPosInt(hrs);
        return h ? `${h}h` : "—";
    };


    const { ingestionEtaSeconds, highMetricHours } = (() => {
        const mode = getCurrentMode();
        if (!selectedGroup) return { ingestionEtaSeconds: 0, highMetricHours: 0 };

        // DEFAULT + ADVANCED: read from selectedGroupScenarios
        if (mode === "Default" || mode === "Advanced") {
            const list =
                mode === "Advanced"
                    ? (selectedGroupScenarios || []).filter(s => s.selected)
                    : (selectedGroupScenarios || []);

            const ingestionSecs = list
                .filter(s => !isDurationScenario(s))         // ✅ only count-mode
                .reduce((sum, s) => sum + countModeContributionSecs(s), 0);

            const hmHrs = list
                .filter(s => isDurationScenario(s))          // ✅ only duration-mode
                .reduce((sum, s) => sum + durationModeHours(s), 0);

            return { ingestionEtaSeconds: ingestionSecs, highMetricHours: hmHrs };
        }

        // RESET: only cleanup scenarios (count-mode)
        const ingestionSecs = (selectedItems || [])
            .filter((t) => t.type === "scenario" || !String(t.id).startsWith("group-"))
            .reduce((sum, t) => {
                const [titlePart, countPart] = String(t.label).split(" - ");
                const cnt = isValidPosInt(countPart) || 1;
                const secs = etaByTitle(t.group, titlePart?.trim());
                return sum + secs * cnt;
            }, 0);

        return { ingestionEtaSeconds: ingestionSecs, highMetricHours: 0 };
    })();



    // TODO: adjust import to your real slice:
    // import { updateTenantDetails } from '../../../Redux/...';

    const handleTenantEditSave = async () => {
        if (!tenantEditDraft) return;

        const {
            tenantUrl,
            itsmUrl,
            accessKey,
            secretKey,
            username,
            password,
        } = tenantEditDraft;

        // Backend doesn’t need id in URL, so ignore tenantEditDraft.id for API

        if (!tenantUrl || !accessKey || !secretKey || !username || !password) {
            await Swal.fire(
                "Incomplete details",
                "BHOM URL, keys and credentials are required.",
                "warning"
            );
            return;
        }

        const payload = {
            tenantUrl,
            itsmUrl,
            key: accessKey,
            secretKey,
            username,
            password,
        };

        try {
            await dispatch(updateTenantDetails(payload));

            await Swal.fire({
                icon: "success",
                title: "Tenant updated",
                text: "Tenant details have been updated successfully.",
                confirmButtonColor: "#05264e",
            });

            setIsTenantEditOpen(false);
            setTenantEditDraft(null);

            // Refresh tenantOptions so dropdown reflects new values
            dispatch(getTenantScenarios());

            // optional: clear local update state
            dispatch(patchUserTenantReset());
        } catch (err) {
            await Swal.fire({
                icon: "error",
                title: "Update failed",
                text: String(err?.message || "Unknown error"),
                confirmButtonColor: "#05264e",
            });
        }
    };




    const handleCancelCurrent = async (row) => {
        const taskId = row.taskId || row.task_id;

        if (!taskId) {
            console.warn('No taskId on row, cannot cancel', row);
            return;
        }

        const result = await Swal.fire({
            title: 'Cancel ingestion?',
            text: 'Are you sure you want to cancel the running ingestion?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Cancel Ingestion',
            cancelButtonText: 'Dismiss',
            customClass: {
                confirmButton: 'btn-yads-primary',
                cancelButton: 'btn-ghost',
            },
            buttonsStyling: false,
        });

        if (!result.isConfirmed) return;

        try {
            const res = await dispatch(cancelIngestion(taskId));
            const msg = res?.success || 'Cancellation requested';

            await Swal.fire({
                icon: 'success',
                title: 'Cancellation requested',
                text: msg,
                confirmButtonText: 'OK',
                customClass: {
                    confirmButton: 'btn-primary',
                },
                buttonsStyling: false,
            });

            window.location.reload();
        } catch (err) {
            await Swal.fire({
                icon: 'error',
                title: 'Cancellation failed',
                text: err?.message || 'Something went wrong while cancelling ingestion.',
                confirmButtonText: 'OK',
                customClass: {
                    confirmButton: 'btn-primary',
                },
                buttonsStyling: false,
            });

            window.location.reload();
        }
    };

    const groupDesc =
        scenarioGroups?.find(g => g.title === selectedGroup)?.description || "";


    return (
        <>
            {globalLoading && <LoadingScreen />}
            <Navbar activeTab={"YADS_INGESTION"} />

            {/* Demo Catalgue Page Start From Here */}
            <div className='background-demo-catalgue'>
                <div className='container'>
                    <div className='yads-container'>
                        {/* Left Panel - Scenario Groups */}
                        <div className='panel scenario-groups'>
                            <h4 className="section-title-yads">Scenario Groups</h4>

                            <div className='scenario-group-list'>
                                {scenarioGroups?.map((group, index) => {
                                    const groupKey = group.title;

                                    return (
                                        <div
                                            key={groupKey}
                                            className={`group-item ${selectedGroup === groupKey ? 'selected' : ''}`}
                                            onClick={() => {
                                                console.log("🔁 Group clicked:", group.title);
                                                console.log("🎯 Current stored mode:", scenarioModes[group.title]);

                                                if (selectedGroup !== group.title) {
                                                    restoreGroupScenarios(group);
                                                }
                                            }}
                                        >
                                            <span >
                                                {group.title}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>


                        {/* Middle Panel - Scenario Details */}
                        <div className={`panel scenario-details ${!selectedGroup ? 'blurred' : ''}`}>


                            {!selectedGroup && (
                                <div className="blur-overlay">
                                    <p>Please select a Scenario Group to continue</p>
                                </div>
                            )}



                            {/* Title and Est Time */}
                            <div className='scenario-header'>
                                <h5 className='group-title'>{selectedGroup}</h5>
                                {/* <span className='est-time'>Est. Time : {selectedGroupScenarios.length * 10} Min</span> */}
                            </div>

                            {/* Description */}
                            <div
                                className="group-description"
                                dangerouslySetInnerHTML={{
                                    __html: groupDesc || "No description available.",
                                }}
                            />




                            {/* Scenario List */}

                            {selectedGroup && (
                                <>



                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
                                        <div className="scenario-mode-tabs">
                                            <span className={`tab ${getCurrentMode() === 'Default' ? 'active' : ''}`} onClick={() => handleScenarioModeChange('Default')}>
                                                Default
                                            </span>
                                            <span className={`tab ${getCurrentMode() === 'Advanced' ? 'active' : ''}`} onClick={() => handleScenarioModeChange('Advanced')}>
                                                Advanced
                                            </span>
                                            <span className={`tab ${getCurrentMode() === 'Reset' ? 'active' : ''}`} onClick={() => handleScenarioModeChange('Reset')}>
                                                Reset
                                            </span>
                                        </div>
                                    </div>
                                    <br />

                                    {getCurrentMode() === 'Advanced' && selectedGroupScenarios.length > 0 && (
                                        <div className="scenario-item select-all-row">
                                            <input
                                                ref={selectAllRef}
                                                type="checkbox"
                                                checked={getAdvancedSelectionState() === 'all'}
                                                onChange={handleSelectAllScenarios}
                                            />
                                            <div className="scenario-info">
                                                <span className="scenario-title">
                                                    Select all in {selectedGroup}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                    {/* Only render scenario list when mode !== 'Default' */}
                                    {getCurrentMode() !== 'Default' && selectedGroupScenarios.length > 0 && selectedGroupScenarios.map((scenario, index) => {
                                        const isInit = isInitScenario(scenario);
                                        console.log("fdkfndf", scenario.estimatedTime);
                                        return (
                                            <div className='scenario-item' key={scenario.id}>

                                                <input
                                                    type="checkbox"
                                                    checked={scenario.selected}
                                                    onChange={() => handleScenarioToggle(index)}

                                                />
                                                <div className='scenario-info'>
                                                    <span className='scenario-title'>{scenario.title}{isInit && ' (required)'}</span>
                                                    {!isDurationScenario(scenario) && (
                                                        <span className="light">
                                                            Est: {scenario?.estimatedTime != null ? formatWords(etaSecs(scenario)) : "N/A"}
                                                        </span>
                                                    )}

                                                    {scenario.description && (
                                                        <p className='scenario-desc'>{scenario.description}</p>
                                                    )}
                                                    {getCurrentMode() === "Advanced" && selectedGroupSupportsHealthIndicator === true && isInit && (
                                                        <div
                                                            className={`health-indicator-config${!scenario.selected ? ' health-indicator-config--disabled' : ''}`}
                                                        >
                                                            <div className="health-indicator-config__content">
                                                                <BsActivity className="health-indicator-config__icon" aria-hidden="true" />
                                                                <div className="health-indicator-config__text">
                                                                    <div
                                                                        className="health-indicator-config__title"
                                                                        id={`health-indicator-title-${scenario.id}`}
                                                                    >
                                                                        Create Health Indicator
                                                                    </div>
                                                                    <p
                                                                        className="health-indicator-config__helper"
                                                                        id={`health-indicator-helper-${scenario.id}`}
                                                                    >
                                                                        Creates health indicator for service predictions
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="health-indicator-config__toggle">
                                                                <Switch
                                                                    id={`create-health-indicator-${scenario.id}`}
                                                                    checked={createHealthIndicator}
                                                                    disabled={!scenario.selected}
                                                                    label="Create Health Indicator"
                                                                    hideLabel
                                                                    ariaDescribedBy={`health-indicator-helper-${scenario.id}`}
                                                                    onChange={(e) => handleCreateHealthIndicatorToggle(e.target.checked, scenario.id)}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="scenario-metric">
                                                    <input
                                                        type="number"
                                                        className="scenario-count"
                                                        value={isDurationScenario(scenario) ? scenario.durationHours : scenario.count}
                                                        min="1"
                                                        onChange={(e) => updateScenarioCount(index, e.target.value)}
                                                        onBlur={(e) => sanitizeScenarioCount(index, e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
                                                        }}
                                                        disabled={isInit}
                                                        title={
                                                            isInit
                                                                ? "Count locked for Init"
                                                                : isDurationScenario(scenario)
                                                                    ? "Enter duration in hours"
                                                                    : "Enter number of runs"
                                                        }
                                                    />
                                                    <span className="scenario-unit-hint">
                                                        {isDurationScenario(scenario) ? "hours" : "runs"}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}





                                    {getCurrentMode() === 'Reset' && (
                                        <div className="reset-message">
                                            <br />
                                            <p>⚠️ You are in Reset mode. Only cleanup scenarios will be added to reset ingestion.</p>

                                            <label className="rtic-reset-option">
                                                <input
                                                    type="checkbox"
                                                    checked={rticReset}
                                                    onChange={(e) => setRticReset(e.target.checked)}
                                                />
                                                <span>RTIC Cluster Reset</span>
                                            </label>


                                            <div className="rtic-warning">
                                                <div className="rtic-warning__icon">⚠️</div>
                                                <div className="rtic-warning__text">
                                                    Enabling this will reset the RTIC cluster across all services. Incidents will be cleared from the cluster but will not be resolved. The service-level reset will resolve incidents for this service.
                                                </div>
                                            </div>

                                        </div>
                                    )}

                                    {/* {getCurrentMode() === 'Default' && selectedGroupScenarios.length > 0 && (
                                        <div className="default-scenario-list">
                                            {selectedGroupScenarios.map((scenario) => (
                                                <div className="scenario-readonly" key={scenario.id}>
                                                    <div className="readonly-header">
                                                        <span className="scenario-title">{scenario.title}</span>

                                                        <span className="scenario-count-readonly">
                                                            {isDurationScenario(scenario)
                                                                ? `${getScenarioValue(scenario)} hour${getScenarioValue(scenario) > 1 ? "s" : ""}`
                                                                : `x${getScenarioValue(scenario)}`}
                                                        </span>
                                                    </div>
                                                    {scenario.description && (
                                                        <div className="scenario-desc">{scenario.description}</div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )} */}

                                    {getCurrentMode() === 'Default' && selectedGroupScenarios.length > 0 && (
                                        <div className="default-scenario-list">
                                            {selectedGroupScenarios.map((scenario) => (
                                                <div className="scenario-readonly" key={scenario.id}>
                                                    <div className="scenario-readonly-info">
                                                        <div className="readonly-header">
                                                            <span className="scenario-title">{scenario.title}</span>
                                                        </div>

                                                        {scenario.description && (
                                                            <div className="scenario-desc">{scenario.description}</div>
                                                        )}
                                                    </div>

                                                    <span className="scenario-count-readonly">
                                                        {isDurationScenario(scenario)
                                                            ? `${getScenarioValue(scenario)} hour${getScenarioValue(scenario) > 1 ? "s" : ""}`
                                                            : `x${getScenarioValue(scenario)}`}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                </>
                            )}



                        </div>

                        {/* Right Panel - Config */}
                        <div className={`panel ingestion-config ${selectedItems.length === 0 ? 'blurred' : ''}`}>

                            {selectedItems.length === 0 && (
                                <div className="blur-overlay">
                                    <p>Please select at least one Scenario or Group</p>
                                </div>
                            )}

                            {/* Selected Items */}
                            <div className="section-header">
                                <h6>Selected Items</h6>
                                <hr />
                            </div>

                            <DragDropContext onDragEnd={handleDragEnd}>
                                <Droppable droppableId="selected-tags" direction="vertical">
                                    {(provided) => (
                                        <div className="selected-tags" {...provided.droppableProps} ref={provided.innerRef}>
                                            {selectedItems.map((item, index) => (
                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                    {(provided) => (
                                                        <span
                                                            className="tag ordered-tag"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <span className="order-index">{index + 1}.</span>
                                                            {item.label}
                                                            <button onClick={() => handleRemoveSelectedItem(item.id)}>×</button>
                                                        </span>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>


                            {/* Tenant Details */}
                            <div className="section-header">
                                <h6>Tenant Details</h6>
                                <hr />
                            </div>

                            <div className="tenant-header-row">
                                <label>Previously Used Tenant</label>

                                {!useNewTenant && canEditSelectedTenant && (
                                    <button
                                        type="button"
                                        className="link-button"
                                        onClick={handleEditExistingTenant}
                                    >
                                        Edit details
                                    </button>
                                )}
                            </div>
                            <div className="tenant-dd-wrapper">
                                <TenantDropdown
                                    options={tenantOptions}
                                    value={tenantDropdownValue}
                                    onChange={(val) => setTenantDropdownValue(val)}
                                    disabled={useNewTenant || !tenantOptions?.length}
                                />
                            </div>

                            <div className={`or-divider ${useNewTenant ? "active" : ""}`}>
                                <button
                                    type="button"
                                    className="or-divider__btn"
                                    onClick={toggleNewTenantMode}
                                    aria-pressed={useNewTenant}
                                >
                                    {useNewTenant ? "Use Existing Tenant Instead" : "Or Use New Tenant"}
                                    <span className="or-divider__icon" aria-hidden>⇄</span>
                                </button>
                            </div>


                            {useNewTenant && (
                                <>
                                    <div className="new-tenant-form">

                                        {/* Tenant URL */}
                                        <label htmlFor="tenant-url">BHOM URL</label>
                                        <input
                                            id="tenant-url"
                                            type="text"
                                            placeholder="https://{tenant}-itom-demo.onbmc.com"
                                            value={tenantInput}
                                            onFocus={() => {
                                                if (!tenantInput && !hasFocusedTenant) {
                                                    const template = 'https://{tenant}-itom-demo.onbmc.com';
                                                    setTenantInput(template);
                                                    setNewTenant((prev) => ({ ...prev, tenantUrl: template }));
                                                }
                                                setHasFocusedTenant(true);
                                            }}
                                            onBlur={() => setHasFocusedTenant(false)}
                                            onChange={handleTenantChange}
                                        />

                                        {/* ITSM URL */}
                                        <label htmlFor="itsm-url">ITSM REST API URL</label>
                                        <input
                                            id="itsm-url"
                                            type="text"
                                            placeholder="https://{tenant}-demo-restapi.onbmc.com"
                                            value={itsmInput}
                                            onFocus={() => {
                                                if (!itsmInput && !hasFocusedITSM) {
                                                    const template = 'https://{tenant}-demo-restapi.onbmc.com';
                                                    setItsmInput(template);
                                                    setNewTenant((prev) => ({ ...prev, itsmUrl: template }));
                                                }
                                                setHasFocusedITSM(true);
                                            }}
                                            onBlur={() => setHasFocusedITSM(false)}
                                            onChange={handleItsmChange}
                                        />

                                        <div className="row">


                                            <div className="field">
                                                <label htmlFor="access-key">ITOM Access Key</label>
                                                <input
                                                    id="access-key"
                                                    type="text"

                                                    value={newTenant.accessKey}
                                                    onChange={(e) => setNewTenant({ ...newTenant, accessKey: e.target.value })}
                                                />
                                            </div>
                                            <div className="field">
                                                <label htmlFor="secret-key">ITOM Secret Key</label>
                                                <input
                                                    id="secret-key"
                                                    type="password"

                                                    value={newTenant.secretKey}
                                                    onChange={(e) => setNewTenant({ ...newTenant, secretKey: e.target.value })}
                                                />
                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className="field">
                                                <label htmlFor="itsm-username">ITSM Username</label>
                                                <input
                                                    id="itsm-username"
                                                    type="text"

                                                    value={newTenant.username}
                                                    onChange={(e) => setNewTenant({ ...newTenant, username: e.target.value })}
                                                />
                                            </div>
                                            <div className="field">
                                                <label htmlFor="itsm-password">ITSM Password</label>
                                                <input
                                                    id="itsm-password"
                                                    type="password"

                                                    value={newTenant.password}
                                                    onChange={(e) => setNewTenant({ ...newTenant, password: e.target.value })}
                                                />
                                            </div>
                                        </div>


                                        {/* Onboard controls (ONLY for new tenant) */}





                                    </div>

                                    {/* <div className="yads-optin-block">
                                        <div className="yads-optin">
                                            <input
                                                id="yads-ntOnboardOptIn"
                                                type="checkbox"
                                                className="yads-checkbox"
                                                checked={ntOnboardOptIn}
                                                onChange={(e) => setNtOnboardOptIn(e.target.checked)}
                                                aria-label="Onboard this tenant into Control-M now"
                                            />
                                            <label htmlFor="yads-ntOnboardOptIn" className="yads-optin__label">
                                                Onboard to Tech Central to ingest logs and metrics for demo catalog narratives
                                            </label>
                                        </div>

                                        {ntOnboardOptIn && (
                                            <div className="yads-inline">
                                                <label htmlFor="yads-nt-hannaPwd" className="yads-label">
                                                    <label className='yads-lab-on'>hannah_admin password</label>
                                                </label>

                                               
                                                <div id="yads-nt-hanna-help" className="yads-callout yads-callout--warn" role="note">
                                                    <span className="yads-callout__icon" aria-hidden="true">⚠️</span>
                                                    <span>
                                                        <strong>Required if you were given a password.</strong> Otherwise, leave this blank to use the default onboarding password.
                                                    </span>
                                                </div>

                                                <div className="yads-inputWrap">
                                                    <input
                                                        id="yads-nt-hannaPwd"
                                                        type="password"
                                                        className="yads-input"

                                                        value={ntHannaPwd}
                                                        onChange={(e) => setNtHannaPwd(e.target.value)}
                                                        autoComplete="new-password"
                                                    />

                                                </div>
                                            </div>
                                        )}
                                    </div> */}
                                </>
                            )}


                            {/* Time + Button */}

                            <div className="yads-estimate__row">
                                <span className="yads-estimate__label">Estimated Ingestion Time :</span>
                                <span className="yads-estimate__right">
                                    <strong className="yads-estimate__value">{formatWords(ingestionEtaSeconds)}</strong>
                                </span>
                            </div>

                            {highMetricHours > 0 && (
                                <div className="yads-estimate__row">
                                    <span className="yads-estimate__label yads-estimate__label--withinfo">
                                        HighMetric Duration <span
                                            className="yads-estimate__info"
                                            title="Metric Agent will run Highmetric in the background for the number of hours selected"
                                            aria-label="HighMetric runs in background"
                                            tabIndex={0}
                                        >
                                            i
                                        </span>:

                                    </span>

                                    <span className="yads-estimate__right">
                                        <strong className="yads-estimate__value">{formatHoursCompact(highMetricHours)}</strong>
                                    </span>
                                </div>
                            )}

                            <button className="start-btn" onClick={handleStartIngestion} disabled={globalLoading}> {globalLoading ? 'Please wait…' : 'Start Ingestion'}</button>
                            {enableIngestionScheduling && (
                                <>
                                    <div className="or-divider"><span>Or</span></div>
                                    <button className="sche-btn" onClick={handleOpenSchedule} disabled={globalLoading}>Schedule Ingestion</button>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <StickyStatusBar
                    statusData={ingestionData}
                    scheduleData={scheduledRows}
                    recurringData={recurringRows}
                    loading={pollingLoading || cancelLoading}
                    error={pollingError}
                    onCancelSchedule={handleCancelSchedule}
                    onEditSchedule={handleEditSchedule}
                    onEditRecurring={handleEditRecurringSchedule}
                    onDisableRecurring={handleToggleRecurring}
                    onCancelRecurring={handleDeleteRecurringSchedule}
                    onCancelCurrent={handleCancelCurrent}
                />




                {enableIngestionScheduling && (
                    <>
                        <ScheduleIngestionModal
                            isOpen={showSchedule}
                            onClose={handleCloseSchedule}
                            tenantUrl={selectedTenantForModal}
                            items={selectedItems}
                            onEditSelection={handleCloseSchedule}
                            onConfirm={handleConfirmSchedule}
                            onConfirmRecurring={handleConfirmRecurringSchedule}
                            loading={scheduleLoading}   // 👈 show “Scheduling…”
                            showHealthIndicatorSchedulingWarning={showHealthIndicatorSchedulingWarning}
                        />

                        <Yads_Ingestion_Scheduled_Edit
                            isOpen={editOpen}
                            onClose={() => setEditOpen(false)}
                            record={editingRecord}
                        />

                        <Yads_Recurring_Scheduled_Edit
                            isOpen={editOpenRecurring}
                            onClose={() => setEditOpenRecurring(false)}
                            record={editingRecordRecurring}
                        />
                    </>
                )}


                <TenantEditModal
                    isOpen={isTenantEditOpen}
                    onClose={() => setIsTenantEditOpen(false)}
                    draft={tenantEditDraft}
                    onChange={setTenantEditDraft}
                    onSave={handleTenantEditSave}
                    saving={false}  // replace with real loading state once you wire Redux
                />


            </div>




        </>
    );
};




export default Yads_Ingestion;




const TenantEditModal = ({ isOpen, onClose, draft, onChange, onSave, saving }) => {
    const handleFieldChange = (field) => (e) => {
        onChange({ ...draft, [field]: e.target.value });
    };

    if (!isOpen || !draft) return null;

    return (
        <div className="tenant-edit-modal-overlay" onClick={onClose}>
            <div
                className="tenant-edit-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="tenant-edit-modal__header">
                    <h3>Edit Tenant Details</h3>
                    <button
                        type="button"
                        className="tenant-edit-modal__close"
                        onClick={onClose}
                    >
                        ✕
                    </button>
                </div>

                <div className="tenant-edit-modal__body">
                    <label className="tenant-edit-label">
                        BHOM URL
                        <input
                            type="text"
                            value={draft.tenantUrl}
                            onChange={handleFieldChange("tenantUrl")}
                            placeholder="https://{tenant}-itom-demo.onbmc.com"
                        />
                    </label>

                    <label className="tenant-edit-label">
                        ITSM REST API URL
                        <input
                            type="text"
                            value={draft.itsmUrl}
                            onChange={handleFieldChange("itsmUrl")}
                            placeholder="https://{tenant}-demo-restapi.onbmc.com"
                        />
                    </label>

                    <div className="tenant-edit-grid">
                        <label className="tenant-edit-label">
                            ITOM Access Key
                            <input
                                type="text"
                                value={draft.accessKey}
                                onChange={handleFieldChange("accessKey")}
                            />
                        </label>

                        <label className="tenant-edit-label">
                            ITOM Secret Key
                            <input
                                type="text"
                                value={draft.secretKey}
                                onChange={handleFieldChange("secretKey")}
                            />
                        </label>
                    </div>

                    <div className="tenant-edit-grid">
                        <label className="tenant-edit-label">
                            ITSM Username
                            <input
                                type="text"
                                value={draft.username}
                                onChange={handleFieldChange("username")}
                            />
                        </label>

                        <label className="tenant-edit-label">
                            ITSM Password
                            <input
                                type="text"
                                value={draft.password}
                                onChange={handleFieldChange("password")}
                            />
                        </label>
                    </div>

                    <p className="tenant-edit-hint">
                        Changes will only affect stored tenant configuration used for future ingestions.
                    </p>



                </div>



                <div className="tenant-edit-modal__footer">
                    <button
                        type="button"
                        className="tenant-edit-btn tenant-edit-btn--ghost"
                        onClick={onClose}
                        disabled={saving}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="tenant-edit-btn tenant-edit-btn--primary"
                        onClick={onSave}
                        disabled={saving}
                    >
                        {saving ? "Saving…" : "Save changes"}
                    </button>
                </div>
            </div>
        </div>
    );
};
